import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { useTranslation } from 'react-i18next';
import { _Api } from "components/api/_call";
import barcodePrintOutContext from "../../context/BarcodePrintOutContext.js";
import Select from "react-select";
import '../../printoutStyle.scss'
import { useLocation } from "react-router-dom";
import PrintPreview from "../PrintPreview";
import InventorySelectToPrintout from "components/inventory/InventorySelectToPrintout";
import { loading, Updateloading, error } from "components/common/helpers/toastify";
import { Label } from "@mobiscroll/react-lite";
import {
    RecoilRoot,
    useRecoilState,

} from 'recoil';
import { pageStatusState, pageHeadingBreadCrumbState, callerFromState } from "../../recoilStateSelector/profilePageState.js";
import { showImportStockIdModalState, selectedInventoryItemsState, countSelectedInventoryItemState, selectedInventoryIdState, exampleCustomPrintOutUriState } from "../../recoilStateSelector/PrintPreviewState.js";
import { CustomTemplateExample } from "components/common/barcodeTemplate/CustomTemplate";
import { formatWeightValue } from "../../../../components/common/barcodeTemplate/printQuantity";
import TableLoader from "admin/common/TableLoader";
import { Document, Page, pdfjs } from "react-pdf";
import {
    FiZoomIn,
    FiZoomOut,
    FiRefreshCw,
    FiLock,
    FiUnlock,
    FiEye,
    FiEyeOff,
} from "react-icons/fi";
import { dataListExample } from "components/common/barcodeTemplate/dataListExample";
import { prepareBarcodeImage } from "components/common/helpers/barcodeImageHelper";
import { encodePriceWithCode } from "components/common/helpers/barcodeHelper";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

let config = {
    template_1: {
        barcode: true,
        item: true,
        item_size: true,
        metal: true,
        weight: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: true, // none code retail_price
        text: true
    },
    template_2: {
        barcode: true,
        qr: true,
        item: true,
        item_size: true,
        metal: true,
        weight: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: false, // none code retail_price
        text: true
    },
    template_3: {
        barcode: true,
        qr: true,
        item: true,
        item_size: true,
        metal: true,
        weight: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: false, // none code retail_price
        text: true
    },
    custom_template_01: {
        barcode: true,
        stock_id: true,
        item: false,
        collection: true,
        item_size: false,
        metal: true,
        weight: true,
        stone_group: false,
        stone_name: true,
        shape: true,
        cut: false,
        color: false,
        clarity: false,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: true, // none code retail_price
        text: false,
        image: false
    }


}


let customTemplateConfig = {
    format: {
        width: 75,
        height: 13
    },
    sku: {
        position: {
            x: 31.5,
            y: 2.5
        }
    },
    collection: {
        position: {
            x: 31.5,
            y: 8.0
        }
    },
    barcode: {
        position: {
            x: 31.5,
            y: 3.3
        },
        size: {
            width: 20,
            height: 4.0
        }
    },
    price: {
        position: {
            x: 31.5,
            y: 12
        }
    },
    stock_id: {
        position: {
            x: 31.5,
            y: 9.8
        }
    },
    item: {
        position: {
            x: 44.5,
            y: 9.8
        }
    },
    item_size: {
        position: {
            x: 44.5,
            y: 9.8
        }
    },
    metal: {
        position: {
            x: 44.5,
            y: 9.8
        }
    },
    weight: {
        position: {
            x: 45.5,
            y: 12
        }
    },
    text: {
        position: {
            x: 45.5,
            y: 12
        }
    },
    stone_data: {
        line_space_offset: 2.5,
        stone_name: {
            position: {
                ontop_x: 0.00,
                x: 55,
                y: 0.00,
                ontop_y: 0.00
            }
        },
        stone_group: {
            position: {
                ontop_x: 0.00,
                x: 60,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        clarity: {
            position: {
                ontop_x: 0.00,
                x: 60,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        stone_size: {
            position: {
                ontop_x: 0.00,
                x: 58,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        shape: {
            position: {
                ontop_x: 0.00,
                x: 55,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        color: {
            position: {
                ontop_x: 0.00,
                x: 60,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        cut: {
            position: {
                ontop_x: 0.00,
                x: 60,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        stone_pcs: {
            position: {
                ontop_x: 0.00,
                x: 65.5,
                y: 0.00,
                ontop_y: 0.00
            }

        },
        stone_weight: {
            position: {
                ontop_x: 0.00,
                x: 69,
                y: 0.00,
                ontop_y: 0.00
            }

        }


    }
}


const normalizeCustomTemplateConfig = (value = {}) => ({
    ...customTemplateConfig,
    ...value,
    collection: {
        ...customTemplateConfig.collection,
        ...(value.collection || {}),
        position: {
            ...customTemplateConfig.collection.position,
            ...(value.collection?.position || {})
        }
    }
});

const getSelectedCustomTemplatePreviewConfig = (baseConfig, selectedFields = []) => {
    const selected = new Set(selectedFields);

    return Object.keys(baseConfig).reduce((previewConfig, fieldName) => {
        previewConfig[fieldName] = selected.has(fieldName);
        return previewConfig;
    }, {});
};

const customPreviewFieldSizes = {
    sku: { width: 24, height: 1.8 },
    barcode: { width: 20, height: 4 },
    stock_id: { width: 12, height: 1.8 },
    collection: { width: 24, height: 1.8 },
    metal: { width: 14, height: 1.8 },
    weight: { width: 14, height: 1.8 },
    price: { width: 24, height: 1.8 },
    stone_name: { width: 8, height: 1.8 },
    stone_group: { width: 8, height: 1.8 },
    clarity: { width: 8, height: 1.8 },
    stone_size: { width: 8, height: 1.8 },
    shape: { width: 8, height: 1.8 },
    color: { width: 8, height: 1.8 },
    cut: { width: 8, height: 1.8 },
    stone_pcs: { width: 6, height: 1.8 },
    stone_weight: { width: 8, height: 1.8 }
};
const customPreviewTextOffset = -1.75;
const customPreviewDraggedObjectScale = 1;
const MAX_PREVIEW_STONE_COUNT = 5;
const DEFAULT_PREVIEW_STONE_COUNT = 2;
const DEFAULT_TEXT_FONT_SIZE = 6;
const PRICE_CODE_FIELDS = [
    ...Array.from({ length: 10 }, (_, index) => ({ key: String(index), label: String(index) })),
    { key: "repeat", label: "Repeat" },
    { key: "00", label: "00" },
];
const PRICE_CODE_DIGIT_FIELDS = PRICE_CODE_FIELDS.filter((field) => /^\d$/.test(field.key));
const PRICE_CODE_SPECIAL_FIELDS = [
    { key: "repeat", label: "Repeat", hint: "Repeats the previous code (a digit or 00)" },
    { key: "00", label: "00", hint: "Used in place of a double zero" },
];
const CUSTOM_TEMPLATE_STONE_FIELDS = [
    "stone_name",
    "stone_group",
    "clarity",
    "stone_size",
    "shape",
    "color",
    "cut",
    "stone_pcs",
    "stone_weight",
];

const normalizePreviewStoneCount = (value) => Math.min(
    MAX_PREVIEW_STONE_COUNT,
    Math.max(1, Math.floor(Number(value) || DEFAULT_PREVIEW_STONE_COUNT))
);

const normalizeTextFontSize = (value) => Math.min(
    20,
    Math.max(1, Number(value) || DEFAULT_TEXT_FONT_SIZE)
);

const customTemplateSourceOptions = [
    { value: "sku", label: "SKU" },
    { value: "barcode", label: "Barcode" },
    { value: "stock_id", label: "Stock ID" },
    { value: "collection", label: "Collection" },
    { value: "metal", label: "Metal" },
    { value: "weight", label: "Weight" },
    { value: "price", label: "Price" },
    { value: "stone_name", label: "Stone Name" },
    { value: "stone_group", label: "Stone Group" },
    { value: "clarity", label: "Clarity" },
    { value: "stone_size", label: "Stone Size" },
    { value: "shape", label: "Shape" },
    { value: "color", label: "Color" },
    { value: "cut", label: "Cut" },
    { value: "stone_pcs", label: "Stone Pcs" },
    { value: "stone_weight", label: "Stone Weight" }
];

const getPreviewFieldText = (
    fieldName,
    previewText = "Text",
    priceDisplay = "retail_price",
    withCode = {}
) => {
    const item = dataListExample[0] || {};
    const stone = item.Stones_Data?.[0] || {};
    const textByField = {
        sku: item.SKU,
        stock_id: item.stock_id,
        collection: item.collection_code || item.collection_name,
        metal: item.metal_code,
        weight: `${formatWeightValue(item.NetWt || item.GrossWt)}g`,
        price: priceDisplay === "with_code"
            ? encodePriceWithCode("31,800.00", withCode)
            : "31,800.00",
        text: previewText || "Text",
        stone_name: stone.stone_details?.code,
        stone_group: stone.stone_group_details?.code,
        clarity: stone.stone_clarity_details?.code,
        stone_size: stone.stone_size_details?.code || stone.size_name,
        shape: stone.stone_shape_details?.code,
        color: stone.stone_color_details?.code,
        cut: stone.stone_cut_details?.code,
        stone_pcs: stone.Pcs,
        stone_weight: `${stone.Cts || ""}${stone.Unit ? stone.Unit.substring(0, 1).toLowerCase() : ""}`
    };

    return textByField[fieldName] || "";
};

const getPreviewStoneFieldText = (fieldName, stoneIndex) => {
    const stones = dataListExample[0]?.Stones_Data || [];
    const stone = stones.length > 0
        ? stones[stoneIndex % stones.length]
        : {};
    const textByField = {
        stone_name: stone.stone_details?.code,
        stone_group: stone.stone_group_details?.code,
        clarity: stone.stone_clarity_details?.code,
        stone_size: stone.stone_size_details?.code || stone.size_name,
        shape: stone.stone_shape_details?.code,
        color: stone.stone_color_details?.code,
        cut: stone.stone_cut_details?.code,
        stone_pcs: stone.Pcs,
        stone_weight: `${stone.Cts || ""}${stone.Unit ? ` ${stone.Unit.substring(0, 1).toLowerCase()}` : ""}`
    };

    return textByField[fieldName] || "";
};

const isPreviewStoneField = (fieldName) => [
    "stone_name",
    "stone_group",
    "clarity",
    "stone_size",
    "shape",
    "color",
    "cut",
    "stone_pcs",
    "stone_weight",
].includes(fieldName);

const measurePreviewTextWidth = (text, fontSize) => {
    if (!text || typeof document === "undefined") return 8;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 8;

    context.font = `bold ${(fontSize * 96) / 72}px Arial`;
    return Math.max(2, (context.measureText(String(text)).width * 25.4) / 96 + 0.4);
};

const CustomTemplatePreviewEditor = ({
    pdfUri,
    customTemplateConfig,
    activeFields,
    onPositionChange,
    onSourceAssign,
    onLockChange,
    forceDefaultSku = true,
    stoneCount,
    onStoneCountChange,
    lineSpacing,
    onLineSpacingChange,
    stoneListVisible = false,
    onStoneListToggle,
    previewText = "Text",
    previewTextFontSize = 6,
    priceDisplay = "retail_price",
    priceCode = {},
    imageConfig,
    onImageChange,
    onSizeChange,
    onPreviewInteractionStart,
    stoneFontSizeByLength = false,
}) => {
    const [previewZoom, setPreviewZoom] = useState(100);
    const previewWidth = 320 * (previewZoom / 100);
    const formatWidth = customTemplateConfig?.format?.width || 75;
    const formatHeight = customTemplateConfig?.format?.height || 13;
    const requestedStoneCount = Math.min(
        MAX_PREVIEW_STONE_COUNT,
        Math.max(1, Math.floor(Number(stoneCount) || 1))
    );
    const displayStoneCount = requestedStoneCount;
    const scale = previewWidth / formatWidth;
    const previewHeight = formatHeight * scale;
    const dragRef = useRef(null);
    const dragHandlersRef = useRef({ move: null, finish: null });
    const previewEditorRef = useRef(null);
    const [selectedField, setSelectedField] = useState(null);
    const [draggingField, setDraggingField] = useState(null);
    const [draggingStoneRow, setDraggingStoneRow] = useState(false);
    const [settlingFields, setSettlingFields] = useState({});
    const [dragPositions, setDragPositions] = useState({});
    const [dragSizes, setDragSizes] = useState({});
    const [dragFontSizes, setDragFontSizes] = useState({});
    const [centerGuide, setCenterGuide] = useState(null);
    const [settlingOriginalPositions, setSettlingOriginalPositions] = useState({});
    const [settlingOriginalSizes, setSettlingOriginalSizes] = useState({});
    const [imageDragOrigin, setImageDragOrigin] = useState(null);
    const [pageReady, setPageReady] = useState(false);
    const [sourceMenu, setSourceMenu] = useState(null);
    const [stoneCountInput, setStoneCountInput] = useState(String(requestedStoneCount));
    const settlingFieldsRef = useRef({});
    const settlingPdfUriRef = useRef(null);
    const activeFieldsSignature = JSON.stringify(activeFields || []);
    const previousActiveFieldsSignatureRef = useRef(activeFieldsSignature);

    useEffect(() => {
        setSelectedField(null);
        setDraggingField(null);
        setSourceMenu(null);

        const hasActiveFieldsChanged = previousActiveFieldsSignatureRef.current !== activeFieldsSignature;
        const hasNewPreviewPdf = Object.keys(settlingFieldsRef.current).length > 0
            && settlingPdfUriRef.current !== pdfUri;

        if (hasActiveFieldsChanged || hasNewPreviewPdf) {
            settlingFieldsRef.current = {};
            settlingPdfUriRef.current = null;
            setSettlingFields({});
            setDragPositions({});
            setDragSizes({});
            setDragFontSizes({});
            setSettlingOriginalPositions({});
            setSettlingOriginalSizes({});
            setImageDragOrigin(null);
        } else if (Object.keys(settlingFieldsRef.current).length === 0) {
            setDragPositions({});
            setDragSizes({});
            setDragFontSizes({});
            setSettlingOriginalPositions({});
            setSettlingOriginalSizes({});
            setImageDragOrigin(null);
        }
        setPageReady(false);
        previousActiveFieldsSignatureRef.current = activeFieldsSignature;
    }, [activeFieldsSignature, pdfUri]);

    useEffect(() => {
        setStoneCountInput(String(requestedStoneCount));
    }, [requestedStoneCount]);

    useEffect(() => {
        if (!sourceMenu) return undefined;

        const closeSourceMenu = () => setSourceMenu(null);
        document.addEventListener("pointerdown", closeSourceMenu);
        window.addEventListener("blur", closeSourceMenu);

        return () => {
            document.removeEventListener("pointerdown", closeSourceMenu);
            window.removeEventListener("blur", closeSourceMenu);
        };
    }, [sourceMenu]);

    const previewFields = useMemo(() => {
        const fieldNames = [...new Set([
            ...(forceDefaultSku ? ["sku"] : []),
            ...activeFields,
            ...(imageConfig?.data ? ["image"] : []),
        ])];
        return fieldNames.filter((fieldName) => (
            (fieldName === "sku" ||
                fieldName === "barcode" ||
                (fieldName === "image" && imageConfig?.data) ||
                getPreviewFieldText(fieldName, previewText, priceDisplay, priceCode)) &&
            (fieldName === "sku" ||
                fieldName === "image" ||
                customTemplateConfig?.[fieldName]?.position ||
                customTemplateConfig?.stone_data?.[fieldName]?.position)
        ));
    }, [activeFields, customTemplateConfig, forceDefaultSku, imageConfig, previewText, priceDisplay, priceCode]);

    const getConfigPosition = (fieldName) => {
        if (fieldName === "image") {
            return imageConfig?.position || { x: 1, y: 1 };
        }
        if (customTemplateConfig?.stone_data?.[fieldName]?.position) {
            return customTemplateConfig.stone_data[fieldName].position;
        }
        return customTemplateConfig?.[fieldName]?.position;
    };

    const getVisualPosition = (fieldName, position, stoneIndex = 0) => {
        if (customTemplateConfig?.stone_data?.[fieldName]?.position) {
            return {
                x: position.x,
                y: position.y + ((customTemplateConfig.stone_data.line_space_offset || 2.5) * (stoneIndex + 1))
            };
        }
        return position;
    };

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const roundPosition = (value) => Math.round(value * 100) / 100;

    useEffect(() => {
        const editor = previewEditorRef.current;
        if (!editor) return undefined;

        const handlePreviewWheel = (event) => {
            if (!event.ctrlKey) return;

            event.preventDefault();
            event.stopPropagation();
            setPreviewZoom((value) => clamp(value + (event.deltaY < 0 ? 25 : -25), 50, 300));
        };

        editor.addEventListener("wheel", handlePreviewWheel, { passive: false });
        return () => editor.removeEventListener("wheel", handlePreviewWheel);
    }, []);

    const startDrag = (event, fieldName, stoneIndex = 0) => {
        if (event.button !== 0) return;
        if (isPreviewStoneField(fieldName) && stoneIndex > 0) return;

        const configPosition = getConfigPosition(fieldName);
        if (!configPosition) return;
        const position = getRenderedPosition(fieldName, configPosition, stoneIndex);

        event.preventDefault();
        event.stopPropagation();
        onPreviewInteractionStart?.();
        dragRef.current = {
            fieldName,
            mode: "move",
            startClientX: event.clientX,
            startClientY: event.clientY,
            startPosition: { x: position.x, y: position.y },
            stoneRow: isPreviewStoneField(fieldName),
            stoneIndex,
        };
        if (fieldName === "image") {
            setImageDragOrigin({
                position: { ...position },
                size: { ...getPreviewFieldSize("image") },
            });
        }
        setSelectedField(fieldName);
        setCenterGuide({ fieldName, position, stoneIndex });
    };

    const startImageResize = (event, corner) => {
        if (event.button !== 0 || !imageConfig?.data) return;

        const position = getConfigPosition("image");
        const size = getPreviewFieldSize("image");
        event.preventDefault();
        event.stopPropagation();
        onPreviewInteractionStart?.();
        dragRef.current = {
            fieldName: "image",
            mode: "resize",
            resizeCorner: corner,
            startClientX: event.clientX,
            startClientY: event.clientY,
            startPosition: { x: position.x, y: position.y },
            startSize: { width: size.width, height: size.height },
        };
        setImageDragOrigin({
            position: { ...position },
            size: { ...size },
        });
        setSelectedField("image");
        setCenterGuide(null);
    };

    const startTextResize = (event, fieldName, stoneIndex, handle) => {
        if (event.button !== 0 || fieldName === "barcode" || fieldName === "image") return;

        const stoneGroup = fieldName === "stone_data";
        const representativeField = stoneGroup
            ? previewFields.find(isPreviewStoneField)
            : fieldName;
        const groupBounds = stoneGroup ? getStoneRowBounds() : null;
        const position = stoneGroup
            ? groupBounds?.position
            : getRenderedPosition(fieldName, getConfigPosition(fieldName), stoneIndex);
        const size = stoneGroup ? groupBounds?.size : getPreviewFieldSize(fieldName, stoneIndex);
        const fontSize = getPreviewFontSize(representativeField, stoneIndex);
        if (!position || !size || !representativeField) return;
        event.preventDefault();
        event.stopPropagation();
        onPreviewInteractionStart?.();
        dragRef.current = {
            fieldName,
            stoneIndex,
            mode: "resize-text",
            resizeCorner: handle,
            startClientX: event.clientX,
            startClientY: event.clientY,
            startPosition: { x: position.x, y: position.y },
            startSize: { ...size },
            startFontSize: fontSize,
            stoneRow: stoneGroup || isPreviewStoneField(fieldName),
            stoneGroup,
            representativeField,
            startStoneSizes: stoneGroup
                ? previewFields.filter(isPreviewStoneField).reduce((sizes, previewFieldName) => ({
                    ...sizes,
                    [previewFieldName]: getPreviewFieldSize(previewFieldName, 0),
                }), {})
                : null,
            startStoneFontSizes: stoneGroup
                ? previewFields.filter(isPreviewStoneField).reduce((fontSizes, previewFieldName) => ({
                    ...fontSizes,
                    [previewFieldName]: getPreviewFontSize(previewFieldName, 0),
                }), {})
                : null,
            startStonePositions: stoneGroup
                ? previewFields.filter(isPreviewStoneField).reduce((positions, previewFieldName) => ({
                    ...positions,
                    [previewFieldName]: { ...getConfigPosition(previewFieldName) },
                }), {})
                : null,
        };
        setSelectedField(fieldName);
        setCenterGuide(null);
    };

    const openSourceMenu = (event, fieldName, position, stoneIndex = 0) => {
        event.preventDefault();
        event.stopPropagation();
        setSelectedField(fieldName);
        setSourceMenu({
            x: event.clientX,
            y: event.clientY,
            fieldName,
            position,
            stoneIndex
        });
    };

    const openSourceMenuAtPage = (event) => {
        event.preventDefault();
        const pageRect = event.currentTarget.getBoundingClientRect();
        const position = {
            x: roundPosition(clamp((event.clientX - pageRect.left) / scale, 0, formatWidth)),
            y: roundPosition(clamp((event.clientY - pageRect.top) / scale, 0, formatHeight))
        };

        setSelectedField(null);
        setSourceMenu({
            x: event.clientX,
            y: event.clientY,
            fieldName: null,
            position
        });
    };

    const selectSource = (sourceKey) => {
        if (!sourceMenu) return;

        onSourceAssign({
            sourceKey,
            previousSourceKey: sourceMenu.fieldName,
            position: sourceMenu.position,
            stoneIndex: sourceMenu.stoneIndex || 0
        });
        setSourceMenu(null);
    };

    const moveDrag = (event) => {
        const drag = dragRef.current;
        if (!drag) return;

        const clientDeltaX = event.clientX - drag.startClientX;
        const clientDeltaY = event.clientY - drag.startClientY;
        if (!drag.moved && Math.hypot(clientDeltaX, clientDeltaY) < 2) return;

        if (!drag.moved) {
            drag.moved = true;
            setDraggingField(drag.fieldName);
            setDraggingStoneRow(drag.stoneRow);
        }

        if (drag.mode === "resize") {
            const deltaX = clientDeltaX / scale;
            const deltaY = clientDeltaY / scale;
            const minSize = 1;
            const maxImageHeight = Math.max(14, formatHeight);
            let nextPosition = { ...drag.startPosition };
            let nextSize = { ...drag.startSize };
            const corner = drag.resizeCorner;

            if (corner.includes("e")) {
                nextSize.width = clamp(drag.startSize.width + deltaX, minSize, formatWidth - drag.startPosition.x);
            }
            if (corner.includes("s")) {
                nextSize.height = clamp(drag.startSize.height + deltaY, minSize, maxImageHeight);
            }
            if (corner.includes("w")) {
                const right = drag.startPosition.x + drag.startSize.width;
                nextPosition.x = clamp(drag.startPosition.x + deltaX, 0, right - minSize);
                nextSize.width = right - nextPosition.x;
            }
            if (corner.includes("n")) {
                const bottom = drag.startPosition.y + drag.startSize.height;
                nextPosition.y = clamp(
                    drag.startPosition.y + deltaY,
                    Math.max(0, bottom - maxImageHeight),
                    bottom - minSize
                );
                nextSize.height = bottom - nextPosition.y;
            }

            nextPosition = {
                x: roundPosition(nextPosition.x),
                y: roundPosition(nextPosition.y),
            };
            nextSize = {
                width: roundPosition(nextSize.width),
                height: roundPosition(nextSize.height),
            };
            drag.position = nextPosition;
            drag.size = nextSize;
            setDragPositions((prev) => ({ ...prev, image: nextPosition }));
            setDragSizes((prev) => ({ ...prev, image: nextSize }));
            return;
        }

        if (drag.mode === "resize-text") {
            const deltaX = clientDeltaX / scale;
            const deltaY = clientDeltaY / scale;
            const corner = drag.resizeCorner;
            const widthRatio = 1 + ((corner.includes("w") ? -deltaX : deltaX)
                / Math.max(drag.startSize.width, 12));
            const heightRatio = 1 + ((corner.includes("n") ? -deltaY : deltaY)
                / Math.max(drag.startSize.height, 6));
            const ratio = corner === "e" || corner === "w"
                ? widthRatio
                : corner === "n" || corner === "s"
                    ? heightRatio
                    : Math.abs(widthRatio - 1) >= Math.abs(heightRatio - 1)
                        ? widthRatio
                        : heightRatio;
            const nextFontSize = clamp(
                roundPosition(drag.startFontSize * ratio),
                1,
                20
            );
            const effectiveRatio = nextFontSize / Math.max(1, drag.startFontSize);
            const nextTextSize = {
                width: measurePreviewTextWidth(
                    isPreviewStoneField(drag.representativeField)
                        ? getPreviewStoneFieldText(drag.representativeField, drag.stoneIndex)
                        : getPreviewFieldText(drag.representativeField, previewText, priceDisplay, priceCode),
                    nextFontSize
                ),
                height: (nextFontSize * 25.4) / 72 + 0.2,
            };
            const nextSize = drag.stoneGroup
                ? {
                    width: roundPosition(drag.startSize.width * effectiveRatio),
                    height: roundPosition(drag.startSize.height * effectiveRatio),
                }
                : nextTextSize;
            const right = drag.startPosition.x + drag.startSize.width;
            const bottom = drag.startPosition.y + drag.startSize.height;
            const rawNextX = corner.includes("w")
                ? right - nextSize.width
                : drag.startPosition.x;
            const rawNextY = corner.includes("n")
                ? bottom - nextSize.height
                : drag.startPosition.y;
            const nextPosition = {
                x: roundPosition(clamp(
                    rawNextX,
                    0,
                    Math.max(0, formatWidth - nextSize.width)
                )),
                y: roundPosition(clamp(
                    rawNextY,
                    0,
                    Math.max(0, formatHeight - nextSize.height)
                )),
            };
            drag.position = nextPosition;
            drag.fontSize = nextFontSize;
            drag.size = nextSize;
            setDragFontSizes((prev) => drag.stoneGroup
                ? Object.keys(drag.startStoneFontSizes || {}).reduce((nextFontSizes, fieldName) => ({
                    ...nextFontSizes,
                    [fieldName]: clamp(
                        roundPosition(drag.startStoneFontSizes[fieldName] * (nextFontSize / drag.startFontSize)),
                        1,
                        20
                    ),
                }), prev)
                : { ...prev, [drag.fieldName]: nextFontSize });
            if (drag.stoneGroup) {
                const delta = {
                    x: nextPosition.x - drag.startPosition.x,
                    y: nextPosition.y - drag.startPosition.y,
                };
                setDragPositions((prev) => Object.keys(drag.startStonePositions || {}).reduce(
                    (nextPositions, fieldName) => ({
                        ...nextPositions,
                        [fieldName]: {
                            x: roundPosition(drag.startStonePositions[fieldName].x + delta.x),
                            y: roundPosition(drag.startStonePositions[fieldName].y + delta.y),
                        },
                    }),
                    prev
                ));
            } else {
                setDragPositions((prev) => ({ ...prev, [drag.fieldName]: nextPosition }));
            }
            return;
        }

        const fieldSize = getPreviewFieldSize(drag.fieldName, drag.stoneIndex || 0);
        const allowOutsideFrame = drag.stoneRow;
        const maxX = drag.fieldName === "image"
            ? Math.max(0, formatWidth - fieldSize.width)
            : formatWidth;
        const maxY = drag.fieldName === "image"
            ? Math.max(0, formatHeight - fieldSize.height)
            : formatHeight;
        const nextPosition = {
            x: roundPosition(allowOutsideFrame
                ? drag.startPosition.x + (clientDeltaX / scale)
                : clamp(drag.startPosition.x + (clientDeltaX / scale), 0, maxX)),
            y: roundPosition(allowOutsideFrame
                ? drag.startPosition.y + (clientDeltaY / scale)
                : clamp(drag.startPosition.y + (clientDeltaY / scale), 0, maxY))
        };
        drag.position = nextPosition;
        setCenterGuide({
            fieldName: drag.fieldName,
            position: nextPosition,
            stoneIndex: drag.stoneIndex || 0,
        });
        setDragPositions((prev) => {
            if (!drag.stoneRow) {
                return { ...prev, [drag.fieldName]: nextPosition };
            }

            const delta = {
                x: nextPosition.x - drag.startPosition.x,
                y: nextPosition.y - drag.startPosition.y,
            };
            const nextPositions = { ...prev };

            previewFields.filter(isPreviewStoneField).forEach((fieldName) => {
                const basePosition = getConfigPosition(fieldName);
                if (!basePosition) return;

                nextPositions[fieldName] = {
                    x: roundPosition(basePosition.x + delta.x),
                    y: roundPosition(basePosition.y + delta.y),
                };
            });

            return nextPositions;
        });
    };

    const finishDrag = () => {
        const drag = dragRef.current;
        if (!drag) return;

        const nextPosition = drag.position || dragPositions[drag.fieldName];
        if (nextPosition && drag.moved) {
            const nextSize = drag.size || dragSizes[drag.fieldName] || getPreviewFieldSize(drag.fieldName, drag.stoneIndex || 0);
            settlingFieldsRef.current = {
                ...settlingFieldsRef.current,
                [drag.fieldName]: true
            };
            settlingPdfUriRef.current = pdfUri;
            if (drag.fieldName === "image") {
                // Keep masking the image position/size baked into the current PDF.
                // Moving or resizing the overlay must not replace that original mask.
                setSettlingOriginalPositions((prev) => prev.image
                    ? prev
                    : { ...prev, image: { ...drag.startPosition } });
                setSettlingOriginalSizes((prev) => prev.image
                    ? prev
                    : { ...prev, image: { ...drag.startSize } });
                setImageDragOrigin({
                    position: { ...drag.startPosition },
                    size: { ...drag.startSize },
                });
                onImageChange?.({
                    ...(imageConfig || {}),
                    position: nextPosition,
                    size: nextSize,
                }, { skipPreviewRender: true });
            }
            if (drag.mode === "resize-text") {
                if (drag.stoneGroup) {
                    setSettlingFields((prev) => ({
                        ...prev,
                        ...previewFields.filter(isPreviewStoneField).reduce((fields, fieldName) => ({
                            ...fields,
                            [fieldName]: true,
                        }), {}),
                    }));
                    setSettlingOriginalPositions((prev) => ({
                        ...prev,
                        ...drag.startStonePositions,
                    }));
                    setSettlingOriginalSizes((prev) => ({
                        ...prev,
                        ...drag.startStoneSizes,
                    }));
                } else {
                    setSettlingFields((prev) => ({ ...prev, [drag.fieldName]: true }));
                    setSettlingOriginalPositions((prev) => prev[drag.fieldName]
                        ? prev
                        : { ...prev, [drag.fieldName]: { ...drag.startPosition } });
                    setSettlingOriginalSizes((prev) => prev[drag.fieldName]
                        ? prev
                        : { ...prev, [drag.fieldName]: { ...drag.startSize } });
                }
                onSizeChange?.({
                    fieldName: drag.fieldName,
                    fontSize: drag.fontSize || drag.startFontSize,
                    fontSizes: drag.stoneGroup
                        ? Object.keys(drag.startStoneFontSizes || {}).reduce((fontSizes, fieldName) => ({
                            ...fontSizes,
                            [fieldName]: clamp(
                                roundPosition(
                                    drag.startStoneFontSizes[fieldName]
                                    * ((drag.fontSize || drag.startFontSize) / drag.startFontSize)
                                ),
                                1,
                                20
                            ),
                        }), {})
                        : undefined,
                    position: drag.stoneGroup ? undefined : nextPosition,
                    positionDelta: drag.stoneGroup
                        ? {
                            x: nextPosition.x - drag.startPosition.x,
                            y: nextPosition.y - drag.startPosition.y,
                        }
                        : undefined,
                    stoneIndex: drag.stoneIndex || 0,
                    lockOffsetX: !drag.stoneGroup && getAlignmentLock(drag.fieldName)?.enabled
                        ? getLockOffset(drag.fieldName, nextPosition, drag.stoneIndex || 0)
                        : undefined,
                    // The local overlay already reflects the final dimensions.
                    // Do not replace the PDF while the editor is settling.
                    skipPreviewRender: true,
                });
            } else if (drag.stoneRow) {
                setSettlingFields((prev) => {
                    const next = { ...prev };
                    previewFields.filter(isPreviewStoneField).forEach((fieldName) => {
                        next[fieldName] = true;
                    });
                    return next;
                });
                setSettlingOriginalPositions((prev) => {
                    const next = { ...prev };
                    previewFields.filter(isPreviewStoneField).forEach((fieldName) => {
                        if (!next[fieldName]) {
                            const basePosition = getConfigPosition(fieldName);
                            next[fieldName] = basePosition ? { ...basePosition } : undefined;
                        }
                    });
                    return next;
                });
                if (drag.fieldName !== "image") onPositionChange(drag.fieldName, nextPosition, {
                    skipPreviewRender: true,
                    stoneRowDelta: {
                        x: nextPosition.x - drag.startPosition.x,
                        y: nextPosition.y - drag.startPosition.y,
                    },
                });
            } else {
                setSettlingFields((prev) => ({ ...prev, [drag.fieldName]: true }));
                if (drag.fieldName !== "image") {
                    setSettlingOriginalPositions((prev) => prev[drag.fieldName]
                        ? prev
                        : {
                            ...prev,
                            [drag.fieldName]: { ...drag.startPosition }
                        });
                }
                if (drag.fieldName !== "image") onPositionChange(drag.fieldName, nextPosition, {
                    skipPreviewRender: true,
                    lockOffsetX: getAlignmentLock(drag.fieldName)?.enabled
                        ? getLockOffset(drag.fieldName, nextPosition, drag.stoneIndex || 0)
                        : undefined,
                });
            }
        }
        setDraggingField(null);
        setDraggingStoneRow(false);
        setCenterGuide(null);
        dragRef.current = null;
    };

    dragHandlersRef.current = { move: moveDrag, finish: finishDrag };

    useEffect(() => {
        const handlePointerMove = (event) => dragHandlersRef.current.move?.(event);
        const finishPointerInteraction = () => dragHandlersRef.current.finish?.();

        window.addEventListener("pointermove", handlePointerMove);
        window.addEventListener("pointerup", finishPointerInteraction);
        window.addEventListener("pointercancel", finishPointerInteraction);
        window.addEventListener("blur", finishPointerInteraction);

        return () => {
            window.removeEventListener("pointermove", handlePointerMove);
            window.removeEventListener("pointerup", finishPointerInteraction);
            window.removeEventListener("pointercancel", finishPointerInteraction);
            window.removeEventListener("blur", finishPointerInteraction);
        };
    }, []);

    const finishPreviewRender = () => {
        setPageReady(true);
    };

    const getPreviewFontSize = (fieldName, stoneIndex = 0) => {
        const isStoneField = isPreviewStoneField(fieldName);
        const draftFontSize = dragFontSizes[fieldName];
        if (Number.isFinite(Number(draftFontSize)) && Number(draftFontSize) > 0) {
            return Number(draftFontSize);
        }
        const draftGroupFontSize = isStoneField ? dragFontSizes.stone_data : null;
        if (Number.isFinite(Number(draftGroupFontSize)) && Number(draftGroupFontSize) > 0) {
            return Number(draftGroupFontSize);
        }
        const fieldConfig = isStoneField
            ? customTemplateConfig?.stone_data?.[fieldName]
            : customTemplateConfig?.[fieldName];
        const configuredFontSize = Number(fieldConfig?.font_size);
        if (Number.isFinite(configuredFontSize) && configuredFontSize > 0) {
            return configuredFontSize;
        }
        const configuredGroupFontSize = isStoneField
            ? Number(customTemplateConfig?.stone_data?.font_size)
            : NaN;
        if (Number.isFinite(configuredGroupFontSize) && configuredGroupFontSize > 0) {
            return configuredGroupFontSize;
        }
        if (stoneFontSizeByLength && isPreviewStoneField(fieldName)) {
            const stoneNameLength = String(getPreviewStoneFieldText("stone_name", stoneIndex) || "").length;
            const shapeLength = String(getPreviewStoneFieldText("shape", stoneIndex) || "").length;
            const longestLength = Math.max(stoneNameLength, shapeLength);
            const fontSizeByLength = {
                2: 5,
                3: 4,
                4: 3,
                5: 3,
            };
            return fontSizeByLength[longestLength] || 5;
        }
        if (fieldName === "collection") return 4;
        if (fieldName === "text") return Number(previewTextFontSize) || 6;
        return 6;
    };

    const renderDraggedObject = (fieldName, stoneIndex = 0) => {
        if (fieldName === "barcode") {
            return <span className="custom_template_preview_barcode_object" />;
        }
        if (fieldName === "image") {
            return (
                <img
                    className="custom_template_preview_image_object"
                    src={imageConfig.data}
                    alt="Label"
                    draggable="false"
                />
            );
        }

        const text = isPreviewStoneField(fieldName)
            ? getPreviewStoneFieldText(fieldName, stoneIndex)
            : getPreviewFieldText(fieldName, previewText, priceDisplay, priceCode);

        return (
            <span
                className="custom_template_preview_text_object"
                style={{ fontSize: `${(getPreviewFontSize(fieldName, stoneIndex) * 96 * (previewZoom / 100) * customPreviewDraggedObjectScale) / 72}px` }}
            >
                {text}
            </span>
        );
    };

    const getPreviewFieldSize = (fieldName, stoneIndex = 0) => {
        if (fieldName === "image") {
            return {
                width: Math.max(1, Number(imageConfig?.size?.width) || 8),
                height: Math.max(1, Number(imageConfig?.size?.height) || 8),
            };
        }
        if (fieldName === "barcode") {
            return {
                width: Math.max(1, Number(customTemplateConfig?.barcode?.size?.width) || customPreviewFieldSizes.barcode.width),
                height: Math.max(1, Number(customTemplateConfig?.barcode?.size?.height) || customPreviewFieldSizes.barcode.height),
            };
        }
        const fontSize = getPreviewFontSize(fieldName, stoneIndex);
        const text = isPreviewStoneField(fieldName)
            ? getPreviewStoneFieldText(fieldName, stoneIndex)
            : getPreviewFieldText(fieldName, previewText, priceDisplay, priceCode);

        return {
            width: measurePreviewTextWidth(text, fontSize),
            height: (fontSize * 25.4) / 72 + 0.2
        };
    };

    const getStoneRowBounds = () => {
        const fields = previewFields
            .filter(isPreviewStoneField)
            .map((fieldName) => {
                const position = getRenderedPosition(
                    fieldName,
                    dragPositions[fieldName] || getConfigPosition(fieldName),
                    0
                );
                const size = getPreviewFieldSize(fieldName, 0);
                return position && size
                    ? {
                        left: position.x,
                        top: position.y + getPreviewFieldTopOffset(fieldName),
                        right: position.x + size.width,
                        bottom: position.y + getPreviewFieldTopOffset(fieldName) + size.height,
                    }
                    : null;
            })
            .filter(Boolean);

        if (fields.length === 0) return null;

        const left = Math.min(...fields.map((field) => field.left));
        const top = Math.min(...fields.map((field) => field.top));
        const right = Math.max(...fields.map((field) => field.right));
        const bottom = Math.max(...fields.map((field) => field.bottom));
        return {
            position: { x: left, y: top },
            size: { width: right - left, height: bottom - top },
        };
    };

    const getAlignmentLock = (fieldName) => customTemplateConfig?.alignment_locks?.[fieldName];

    const getLockedPosition = (fieldName, position, stoneIndex = 0) => {
        const lock = getAlignmentLock(fieldName);
        if (!lock?.enabled || lock.target !== "barcode" || lock.axis !== "center") {
            return position;
        }

        const barcodePosition = customTemplateConfig?.barcode?.position;
        const barcodeSize = customTemplateConfig?.barcode?.size || { width: 20, height: 4 };
        if (!barcodePosition) return position;

        const textSize = getPreviewFieldSize(fieldName, stoneIndex);
        const barcodeCenter = Number(barcodePosition.x) + (Number(barcodeSize.width) / 2) + (Number(lock.offset_x) || 0);
        return {
            ...position,
            x: barcodeCenter - (textSize.width / 2),
        };
    };

    const getRenderedPosition = (fieldName, position, stoneIndex = 0, skipLock = false) => (
        getVisualPosition(
            fieldName,
            skipLock ? position : getLockedPosition(fieldName, position, stoneIndex),
            stoneIndex
        )
    );

    const getBarcodeCenter = () => {
        const barcodePosition = customTemplateConfig?.barcode?.position;
        const barcodeSize = customTemplateConfig?.barcode?.size || { width: 20, height: 4 };
        return barcodePosition
            ? Number(barcodePosition.x) + (Number(barcodeSize.width) / 2)
            : null;
    };

    const getLockOffset = (fieldName, position, stoneIndex = 0) => {
        const barcodeCenter = getBarcodeCenter();
        if (barcodeCenter === null) return 0;
        const fieldSize = getPreviewFieldSize(fieldName, stoneIndex);
        return roundPosition(position.x + (fieldSize.width / 2) - barcodeCenter);
    };

    const toggleAlignmentLock = (fieldName, stoneIndex = 0) => {
        const lock = getAlignmentLock(fieldName);
        const position = getConfigPosition(fieldName);
        if (!position) return;

        const renderedPosition = getRenderedPosition(fieldName, position, stoneIndex);
        onLockChange?.({
            fieldName,
            enabled: !lock?.enabled,
            offsetX: !lock?.enabled ? getLockOffset(fieldName, renderedPosition, stoneIndex) : 0,
        });
    };

    const getPreviewFieldTopOffset = (fieldName) => (
        fieldName === "barcode" || fieldName === "image" ? 0 : customPreviewTextOffset
    );

    const getSettlingMaskRect = (fieldName, position, size, topOffset) => {
        const rect = {
            left: position.x,
            top: position.y + topOffset,
            width: size.width,
            height: size.height
        };

        if (fieldName === "barcode") {
            const padding = 0.35;
            return {
                left: rect.left - padding,
                top: rect.top - padding,
                width: rect.width + (padding * 2),
                height: rect.height + (padding * 2),
            };
        }
        if (fieldName === "image") return rect;

        const barcodePosition = settlingOriginalPositions.barcode || getConfigPosition("barcode");
        if (!barcodePosition) return rect;

        const barcodeSize = getPreviewFieldSize("barcode");
        const barcodeBottom = barcodePosition.y + barcodeSize.height;
        const overlapsBarcode = rect.left < barcodePosition.x + barcodeSize.width
            && rect.left + rect.width > barcodePosition.x
            && rect.top < barcodeBottom
            && rect.top + rect.height > barcodePosition.y;

        if (!overlapsBarcode) return rect;

        const clippedTop = Math.max(rect.top, barcodeBottom);
        return {
            ...rect,
            top: clippedTop,
            height: Math.max(0, rect.top + rect.height - clippedTop)
        };
    };

    const renderCenterGuide = () => {
        if (!centerGuide || centerGuide.fieldName === "barcode") return null;

        const barcodeCenter = getBarcodeCenter();
        if (barcodeCenter === null) return null;

        const position = centerGuide.position;
        const size = getPreviewFieldSize(centerGuide.fieldName, centerGuide.stoneIndex || 0);
        const topOffset = getPreviewFieldTopOffset(centerGuide.fieldName);
        const objectCenter = position.x + (size.width / 2);
        const isAligned = Math.abs(objectCenter - barcodeCenter) <= 0.25;

        return (
            <div className={`custom_template_preview_alignment_guides ${isAligned ? "is-aligned" : ""}`} aria-hidden="true">
                <span
                    className="custom_template_preview_alignment_line custom_template_preview_alignment_line_reference"
                    style={{ left: barcodeCenter * scale }}
                />
                <span
                    className="custom_template_preview_alignment_line custom_template_preview_alignment_line_object"
                    style={{ left: objectCenter * scale }}
                />
                <span
                    className="custom_template_preview_alignment_marker"
                    style={{
                        left: objectCenter * scale,
                        top: Math.max(0, (position.y + topOffset) * scale),
                    }}
                />
            </div>
        );
    };

    const hasPreviewOverlay = draggingField !== null || Object.keys(settlingFields).length > 0;
    const isMovedPreviewField = (fieldName) => (
        settlingFields[fieldName]
        || (draggingStoneRow && isPreviewStoneField(fieldName))
        || draggingField === fieldName
    );

    const previewRectsOverlap = (first, second) => (
        first.left < second.left + second.width
        && first.left + first.width > second.left
        && first.top < second.top + second.height
        && first.top + first.height > second.top
    );

    const movedPreviewMaskRects = hasPreviewOverlay
        ? previewFields
            .flatMap((fieldName) => isPreviewStoneField(fieldName)
                ? Array.from({ length: displayStoneCount }, (_, stoneIndex) => ({ fieldName, stoneIndex }))
                : [{ fieldName, stoneIndex: 0 }])
            .filter(({ fieldName }) => isMovedPreviewField(fieldName))
            .map(({ fieldName, stoneIndex }) => {
                const position = dragPositions[fieldName] || getConfigPosition(fieldName);
                if (!position) return null;

                const originalPosition = settlingOriginalPositions[fieldName] || getConfigPosition(fieldName);
                if (!originalPosition) return null;

                const visualPosition = getRenderedPosition(fieldName, originalPosition, stoneIndex);
                const size = settlingOriginalSizes[fieldName]
                    || getPreviewFieldSize(fieldName, stoneIndex);
                return getSettlingMaskRect(fieldName, visualPosition, size, getPreviewFieldTopOffset(fieldName));
            })
            .filter(Boolean)
        : [];

    const previewStoneFields = previewFields.filter(isPreviewStoneField);
    const stoneRowResizeBounds = selectedField
        && isPreviewStoneField(selectedField)
        && !draggingField
        ? getStoneRowBounds()
        : null;
    const imageOriginalPosition = settlingOriginalPositions.image
        || (draggingField === "image" ? imageDragOrigin?.position : null);
    const imageOriginalSize = settlingOriginalSizes.image
        || (draggingField === "image" ? imageDragOrigin?.size : null)
        || getPreviewFieldSize("image");
    const imageOriginalMaskRect = imageOriginalPosition
        ? getSettlingMaskRect(
            "image",
            getRenderedPosition("image", imageOriginalPosition, 0),
            imageOriginalSize,
            0
        )
        : null;
    return (
        <div className="custom_template_preview_editor" ref={previewEditorRef}>
            <div className="custom_template_preview_toolbar">
                <button
                    type="button"
                    className="custom_template_preview_zoom_button"
                    onClick={() => setPreviewZoom((value) => Math.max(50, value - 25))}
                    disabled={previewZoom <= 50}
                    aria-label="Zoom out"
                    title="Zoom out"
                >
                    <FiZoomOut aria-hidden="true" />
                </button>
                <span className="custom_template_preview_zoom_value">{previewZoom}%</span>
                <button
                    type="button"
                    className="custom_template_preview_zoom_button"
                    onClick={() => setPreviewZoom((value) => Math.min(300, value + 25))}
                    disabled={previewZoom >= 300}
                    aria-label="Zoom in"
                    title="Zoom in"
                >
                    <FiZoomIn aria-hidden="true" />
                </button>
                <button
                    type="button"
                    className="custom_template_preview_zoom_button"
                    onClick={() => setPreviewZoom(100)}
                    disabled={previewZoom === 100}
                    aria-label="Reset zoom"
                    title="Reset zoom"
                >
                    <FiRefreshCw aria-hidden="true" />
                </button>
                {typeof onStoneCountChange === "function" && (
                    <label className="custom_template_preview_stone_count">
                        <span>Stone count</span>
                        <input
                            type="number"
                            min="1"
                            max={MAX_PREVIEW_STONE_COUNT}
                            value={stoneCountInput}
                            onChange={(event) => {
                                const rawValue = event.target.value;
                                setStoneCountInput(rawValue);
                                if (rawValue === "") return;

                                const nextCount = Math.min(
                                    MAX_PREVIEW_STONE_COUNT,
                                    Math.max(1, Math.floor(Number(rawValue) || 1))
                                );
                                onStoneCountChange(nextCount);
                            }}
                            onBlur={() => {
                                if (stoneCountInput === "") {
                                    setStoneCountInput(String(requestedStoneCount));
                                }
                            }}
                        />
                    </label>
                )}
                {typeof onLineSpacingChange === "function" && (
                    <label className="custom_template_preview_stone_count">
                        <span>Line spacing</span>
                        <input
                            type="number"
                            min="0.5"
                            max="5"
                            step="0.1"
                            value={lineSpacing}
                            onChange={(event) => {
                                const nextSpacing = Math.min(
                                    5,
                                    Math.max(0.5, parseFloat(event.target.value) || 0.5)
                                );
                                onLineSpacingChange(nextSpacing);
                            }}
                        />
                    </label>
                )}
                {typeof onStoneListToggle === "function" && (
                    <button
                        type="button"
                        className={`custom_template_preview_toggle_button ${stoneListVisible ? "is-active" : ""}`}
                        onClick={onStoneListToggle}
                        title={stoneListVisible ? "Hide stone list" : "Show stone list"}
                        aria-label={stoneListVisible ? "Hide stone list" : "Show stone list"}
                    >
                        {stoneListVisible
                            ? <FiEye aria-hidden="true" />
                            : <FiEyeOff aria-hidden="true" />}
                    </button>
                )}
            </div>
            <Document file={pdfUri} loading="">
                <div
                    className="custom_template_preview_page"
                    style={{ width: previewWidth, height: previewHeight }}
                    onContextMenu={openSourceMenuAtPage}
                >
                    <Page
                        pageNumber={1}
                        width={previewWidth}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        onRenderSuccess={finishPreviewRender}
                    />
                    {pageReady ?
                        <div className="custom_template_preview_drag_layer">
                            {imageOriginalMaskRect && imageConfig?.data ? (
                                <div
                                    className="custom_template_preview_image_original_mask"
                                    style={{
                                        left: imageOriginalMaskRect.left * scale,
                                        top: imageOriginalMaskRect.top * scale,
                                        width: imageOriginalMaskRect.width * scale,
                                        height: imageOriginalMaskRect.height * scale,
                                    }}
                                />
                            ) : null}
                            {renderCenterGuide()}
                            {previewFields
                                .flatMap((fieldName) => isPreviewStoneField(fieldName)
                                    ? Array.from({ length: displayStoneCount }, (_, stoneIndex) => ({ fieldName, stoneIndex }))
                                    : [{ fieldName, stoneIndex: 0 }])
                                .map(({ fieldName, stoneIndex }) => {
                                     const isDisplayOnlyRow = isPreviewStoneField(fieldName) && stoneIndex > 0;
                                     const isStoneRowActive = draggingStoneRow && isPreviewStoneField(fieldName);
                                     const isFieldDragging = draggingField === fieldName || isStoneRowActive;
                                     const position = dragPositions[fieldName] || getConfigPosition(fieldName);
                                     const visualPosition = getRenderedPosition(
                                         fieldName,
                                         position,
                                         stoneIndex,
                                         isFieldDragging
                                     );
                                     const size = dragSizes[fieldName]
                                         || getPreviewFieldSize(fieldName, stoneIndex);
                                    const topOffset = getPreviewFieldTopOffset(fieldName);
                                    const originalPosition = settlingOriginalPositions[fieldName]
                                        || getConfigPosition(fieldName);
                                     const originalVisualPosition = getRenderedPosition(fieldName, originalPosition, stoneIndex);
                                     const originalSize = settlingOriginalSizes[fieldName]
                                         || getPreviewFieldSize(fieldName, stoneIndex);
                                     const maskRect = getSettlingMaskRect(fieldName, originalVisualPosition, originalSize, topOffset);
                                    const shouldRenderSettledClone = settlingFields[fieldName];

                                    const fieldStyle = {
                                        left: visualPosition.x * scale,
                                        top: (visualPosition.y + topOffset) * scale,
                                        width: size.width * scale,
                                        height: size.height * scale,
                                        zIndex: isFieldDragging ? 40 : selectedField === fieldName ? 35 : 30,
                                    };
                                    const draggedObject = isFieldDragging || shouldRenderSettledClone
                                        ? renderDraggedObject(fieldName, stoneIndex)
                                        : null;

                                    return (
                                        <React.Fragment key={`${fieldName}-${stoneIndex}`}>
                                            {isFieldDragging || shouldRenderSettledClone ?
                                                <div
                                                     className={`custom_template_preview_drag_mask${fieldName === "image" ? " custom_template_preview_image_drag_mask" : ""}`}
                                                    style={{
                                                        left: maskRect.left * scale,
                                                        top: maskRect.top * scale,
                                                        width: maskRect.width * scale,
                                                        height: maskRect.height * scale
                                                    }}
                                                />
                                                : null}
                                            {isDisplayOnlyRow ?
                                                <div className="custom_template_preview_display_row" style={fieldStyle}>
                                                    {draggedObject}
                                                </div>
                                                :
                                                <div
                                                    className={`custom_template_preview_field ${selectedField === fieldName ? "is-selected" : ""} ${isFieldDragging || shouldRenderSettledClone ? "is-dragging" : ""}`}
                                                    style={fieldStyle}
                                                    onPointerDown={(event) => startDrag(event, fieldName, stoneIndex)}
                                                     onContextMenu={fieldName === "image"
                                                         ? (event) => event.preventDefault()
                                                         : (event) => openSourceMenu(event, fieldName, visualPosition, stoneIndex)}
                                                >
                                                    {draggedObject}
                                                     {fieldName === "image" ? (
                                                         <>
                                                             {["nw", "n", "ne", "sw", "s", "se"].map((corner) => (
                                                                 <span
                                                                     key={corner}
                                                                     className={`custom_template_preview_resize_handle is-${corner}`}
                                                                     onPointerDown={(event) => startImageResize(event, corner)}
                                                                 />
                                                             ))}
                                                         </>
                                                     ) : fieldName !== "barcode" ?
                                                         <>
                                                             {!isPreviewStoneField(fieldName) && ["nw", "n", "ne", "sw", "s", "se"].map((corner) => (
                                                                 <span
                                                                     key={corner}
                                                                     className={`custom_template_preview_resize_handle is-${corner}`}
                                                                     onPointerDown={(event) => startTextResize(event, fieldName, stoneIndex, corner)}
                                                                 />
                                                             ))}
                                                             {(!isPreviewStoneField(fieldName) || fieldName === previewStoneFields[0]) && (
                                                             <button
                                                                 type="button"
                                                                 className={`custom_template_preview_lock_button ${getAlignmentLock(fieldName)?.enabled ? "is-locked" : ""}`}
                                                                 title={getAlignmentLock(fieldName)?.enabled
                                                                     ? "Unlock barcode alignment"
                                                                     : "Keep centered on barcode"}
                                                                 aria-label={getAlignmentLock(fieldName)?.enabled
                                                                     ? "Unlock barcode alignment"
                                                                     : "Keep centered on barcode"}
                                                                 onPointerDown={(event) => {
                                                                     event.preventDefault();
                                                                     event.stopPropagation();
                                                                 }}
                                                                 onClick={(event) => {
                                                                     event.preventDefault();
                                                                     event.stopPropagation();
                                                                     toggleAlignmentLock(fieldName, stoneIndex);
                                                                 }}
                                                             >
                                                                 {getAlignmentLock(fieldName)?.enabled
                                                                     ? <FiLock aria-hidden="true" />
                                                                     : <FiUnlock aria-hidden="true" />}
                                                             </button>
                                                             )}
                                                         </>
                                                         : null}
                                                </div>}
                                        </React.Fragment>
                                    );
                                })}
                            {stoneRowResizeBounds ? (
                                <div
                                    className="custom_template_preview_stone_resize_field"
                                    style={{
                                        left: stoneRowResizeBounds.position.x * scale,
                                        top: stoneRowResizeBounds.position.y * scale,
                                        width: stoneRowResizeBounds.size.width * scale,
                                        height: stoneRowResizeBounds.size.height * scale,
                                    }}
                                >
                                    {["nw", "n", "ne", "sw", "s", "se"].map((corner) => (
                                        <span
                                            key={corner}
                                            className={`custom_template_preview_resize_handle is-${corner}`}
                                            onPointerDown={(event) => startTextResize(event, "stone_data", 0, corner)}
                                        />
                                    ))}
                                </div>
                            ) : null}
                            {hasPreviewOverlay ?
                                previewFields
                                    .flatMap((fieldName) => isPreviewStoneField(fieldName)
                                        ? Array.from({ length: displayStoneCount }, (_, stoneIndex) => ({ fieldName, stoneIndex }))
                                        : [{ fieldName, stoneIndex: 0 }])
                                    .filter(({ fieldName, stoneIndex }) => {
                                        if (isMovedPreviewField(fieldName)) return false;

                                        const originalPosition = getConfigPosition(fieldName);
                                        if (!originalPosition) return false;

                                         const visualPosition = getRenderedPosition(fieldName, originalPosition, stoneIndex);
                                         const size = dragSizes[fieldName]
                                             || getPreviewFieldSize(fieldName, stoneIndex);
                                        const fieldRect = {
                                            left: visualPosition.x,
                                            top: visualPosition.y + getPreviewFieldTopOffset(fieldName),
                                            width: size.width,
                                            height: size.height,
                                        };

                                        return movedPreviewMaskRects.some((maskRect) => previewRectsOverlap(fieldRect, maskRect));
                                    })
                                    .map(({ fieldName, stoneIndex }) => {
                                        const originalPosition = getConfigPosition(fieldName);
                                        if (!originalPosition) return null;

                                         const originalVisualPosition = getRenderedPosition(fieldName, originalPosition, stoneIndex);
                                        const size = getPreviewFieldSize(fieldName, stoneIndex);
                                        const topOffset = getPreviewFieldTopOffset(fieldName);
                                        const fieldRect = {
                                            left: originalVisualPosition.x,
                                            top: originalVisualPosition.y + topOffset,
                                            width: size.width,
                                            height: size.height,
                                        };
                                        const overlappingMask = movedPreviewMaskRects.find((maskRect) => (
                                            previewRectsOverlap(fieldRect, maskRect)
                                        ));
                                        if (!overlappingMask) return null;

                                        const intersection = {
                                            left: Math.max(fieldRect.left, overlappingMask.left),
                                            top: Math.max(fieldRect.top, overlappingMask.top),
                                            right: Math.min(fieldRect.left + fieldRect.width, overlappingMask.left + overlappingMask.width),
                                            bottom: Math.min(fieldRect.top + fieldRect.height, overlappingMask.top + overlappingMask.height),
                                        };
                                        const clipTop = Math.max(0, (intersection.top - fieldRect.top) * scale);
                                        const clipRight = Math.max(0, (fieldRect.left + fieldRect.width - intersection.right) * scale);
                                        const clipBottom = Math.max(0, (fieldRect.top + fieldRect.height - intersection.bottom) * scale);
                                        const clipLeft = Math.max(0, (intersection.left - fieldRect.left) * scale);

                                        return (
                                            <div
                                                key={`base-overlay-${fieldName}-${stoneIndex}`}
                                                className="custom_template_preview_display_row"
                                                style={{
                                                    left: originalVisualPosition.x * scale,
                                                    top: (originalVisualPosition.y + topOffset) * scale,
                                                    width: size.width * scale,
                                                    height: size.height * scale,
                                                    zIndex: 25,
                                                    clipPath: `inset(${clipTop}px ${clipRight}px ${clipBottom}px ${clipLeft}px)`,
                                                }}
                                            >
                                                {renderDraggedObject(fieldName, stoneIndex)}
                                            </div>
                                        );
                                    })
                                : null}
                        </div>
                        : null}
            {sourceMenu ?
                <div
                    className="custom_template_preview_source_menu"
                    style={{ left: sourceMenu.x, top: sourceMenu.y }}
                    onPointerDown={(event) => event.stopPropagation()}
                    onContextMenu={(event) => event.preventDefault()}
                >
                    <div className="custom_template_preview_source_menu_title">Use source</div>
                    {customTemplateSourceOptions.map((source) => (
                        <button
                            type="button"
                            className={`custom_template_preview_source_option ${source.value === sourceMenu.fieldName ? "is-current" : ""}`}
                            key={source.value}
                            onClick={() => selectSource(source.value)}
                        >
                            <span>{source.label}</span>
                            {activeFields.includes(source.value) || source.value === "sku" ? <span aria-hidden="true">✓</span> : null}
                        </button>
                    ))}
                </div>
                : null}
                </div>
            </Document>
        </div>
    );
};

const selectLimitOptions = [
    { label: 10, value: 10 },
    { label: 50, value: 50 },
    { label: 100, value: 100 }
]


const BarcodePrintOutPage = () => {


    const { hash } = useLocation();

    let selectOptions = [
        { label: "please select template name", value: "" },

        {
            label: "Custom-Template-01-Barcode",
            value: "custom_template_01"
        }

    ];
    const [limit, setLimit] = useState(50);
    let [exampleCustomPrintOutUri, setExampleCustomPrintOutUri] = useRecoilState(exampleCustomPrintOutUriState)

    let [pageStatus, setPageStatus] = useRecoilState(pageStatusState)
    let [PageHeadingBreadCrumb, setPageHeadingBreadCrumb] = useRecoilState(pageHeadingBreadCrumbState)
    let [callerFrom,] = useRecoilState(callerFromState)
    const [showImportStockIdModal, setShowImportStockIdModal] = useRecoilState(showImportStockIdModalState)
    const { t } = useTranslation();
    const [stockIdImportList, setStockIdImportList] = useState(false)
    const [selectedInventoryItems, setSelectedInventoryItems] = useRecoilState(selectedInventoryItemsState)

    const [countSelectedInventoryItem, setCountSelectedInventoryItem] = useRecoilState(countSelectedInventoryItemState)

    const [selectedInventoryId, setSelectedInventoryId] = useRecoilState(selectedInventoryIdState)

    const [checkConfigData, setCheckConfigData] = useState({ config_check_list: [], config_check_info: {}, current_template_layout_selected: "", selected_options: selectOptions, custom_template_config: customTemplateConfig })

    const goToListPage = () => {
        console.log('d')
        setPageStatus("list_profile_page")
        setPageHeadingBreadCrumb({
            heading: "Barcode Label",
            breadCrumbName: "Barcode",

        })
        setCheckConfigData({ config_check_list: [], config_check_info: {}, current_template_layout_selected: "", selected_options: selectOptions, custom_template_config: customTemplateConfig })
    }




    const [configList, setConfigList] = useState();
    const [profileId, setProfileId] = useState(false)
    const [reload, setReload] = useState(false);
    const [checkedLabelIds, setCheckedLabelIds] = useState([]);
    const [showloader, setShowloader] = useState(false);
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    function isNumeric(str) {
        return /^\d+$/.test(str);
    }
    const importStockIdList = async () => {

        if (isNumeric(stockIdImportList.replace(/\s/g, "").replace(/\n/g, ""))) {
            const listImport = stockIdImportList.split("\n");
            var filteredListImport = listImport.filter(function (el) {
                return el !== null && el !== "";
            });
            const postdata = {
                "item": [],
                "collection": [],
                "metal": [],
                "size": [],
                "stone": [],
                "productStatus": [],
                "location": [],
                "price": [],
                "search": filteredListImport === "" ? "" : filteredListImport,
                "limit": 100,
                "skip": 0,
            };
            console.log(selectedInventoryId.some(r => filteredListImport.includes(r)), 'listImport data')


            if (!selectedInventoryId.some(r => filteredListImport.includes(r))) {
                const searchImport = await _Api(postdata, "api/v1/Inventory/my/list/search/by-stock-id")
                setSelectedInventoryItems((prev) => {
                    let obj;
                    if (prev) {
                        obj = [...prev, ...searchImport.data]

                    } else {
                        obj = [prev];
                    }
                    return obj;
                })
                setCountSelectedInventoryItem(countSelectedInventoryItem + searchImport.data.length)

                setSelectedInventoryId(filteredListImport)
                setShowImportStockIdModal(false)
                setStockIdImportList(false)
            }


        } else {
            console.log(stockIdImportList.replace(/\s/g, "").replace(/\n/g, ""))
            alert(t("Please Input Only Number In Stock_ID ( Ex. 200001 ) "))
        }
    }
    const deleteProfileTemplate = async (_id) => {

        const deleteProfile = await _Api({ _id: _id }, "api/v1/template-printout/delete");

        if (deleteProfile) {

            setReload(!reload)
            window.location.reload(false)
        }
    }

    const customTemplateList = (configList || []).filter((v) =>
        v.template_layout === "custom_template_01" || v.template_layout === "custom_template_02"
    );

    const fetchConfigList = async () => {
        setShowloader(true);
        try {
            const listDataConfig = await _Api({ template_type: "barcode_printout_template" }, "api/v1/template-printout/list");
            const { data } = listDataConfig;
            setConfigList(data)
        } catch (err) {
            setConfigList([])
        } finally {
            setShowloader(false);
        }
    }

    const handleLabelCheck = (e, id) => {
        if (e.target.checked) {
            setCheckedLabelIds((prev) => prev.includes(id) ? prev : [...prev, id]);
        } else {
            setCheckedLabelIds((prev) => prev.filter((x) => x !== id));
        }
    };

    const handleCheckAllLabels = (e) => {
        if (e.target.checked) {
            setCheckedLabelIds(customTemplateList.map((v) => v._id));
        } else {
            setCheckedLabelIds([]);
        }
    };

    const cloneProfileTemplate = async () => {
        if (checkedLabelIds.length !== 1) {
            return;
        }
        const GetloadingID = loading();
        try {
            const res = await _Api({ _id: checkedLabelIds[0] }, "api/v1/template-printout/clone");
            if (res?.code === 200) {
                Updateloading(t, GetloadingID, res?.message || t("Template cloned"));
                setCheckedLabelIds([]);
                await fetchConfigList();
            } else {
                Updateloading(t, GetloadingID, res?.message || t("Template not found"), "error");
            }
        } catch (err) {
            Updateloading(t, GetloadingID, t("Template not found"), "error");
        }
    }
    const genUri = async (config) => {

        const previewConfig = {
            ...getSelectedCustomTemplatePreviewConfig(config.custom_template_01, checkConfigData.config_check_list),
            preview_stone_count: normalizePreviewStoneCount(checkConfigData.config_check_info?.preview_stone_count),
            price_display: checkConfigData.config_check_info?.price_display || "retail_price",
            with_code: checkConfigData.config_check_info?.with_code || {},
        };
        let uridata = await CustomTemplateExample(previewConfig, checkConfigData.custom_template_config)
        console.log(uridata, 'uridata')

        // const blob = fetch(uridata).then(res => res.blob());
        // blob.then(pdfBlob => {
        //   const blobUrl = URL.createObjectURL(pdfBlob);
        //   setPdfUri(blobUrl)

        // });

        // (templateProfileId, selectList, dataList, returnType = "save")

        // Base64 string (example, replace with your Base64 string)

        if (uridata) {

            const base64String = uridata.replace('data:application/pdf;filename=generated.pdf;base64,', ''); // Your Base64 content (excluding "data:application/pdf;base64,")
            //  console.log(base64String,'base64String')
            // Step 1: Decode the Base64 string
            const binaryString = atob(base64String);

            // Step 2: Convert binary string to Uint8Array
            const binaryData = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                binaryData[i] = binaryString.charCodeAt(i);
            }

            // Step 3: Create a Blob from the binary data
            const blob = new Blob([binaryData], { type: "application/pdf" });

            // Step 4: Create an Object URL
            const objectUrl = URL.createObjectURL(blob);

            // Step 5: Assign Object URL to the iframe
            setExampleCustomPrintOutUri(objectUrl)
        }




    }
    const editProfile = async (_id) => {

        const listDataConfig = await _Api({ _id: _id }, "api/v1/template-printout/getByid");

        setCheckConfigData((prev) => {
            const profileSetupInfo = listDataConfig.data.profile_setup_info || {};
            const sourceInfo = listDataConfig.data.config_check_info || {};
            const configInfo = {
                ...sourceInfo,
                _id: listDataConfig.data._id,
                text_message: sourceInfo.text_message ?? profileSetupInfo.text_message ?? listDataConfig.data.text_message ?? "",
                text_font_size: sourceInfo.text_font_size ?? profileSetupInfo.text_font_size ?? listDataConfig.data.text_font_size ?? DEFAULT_TEXT_FONT_SIZE,
                price_display: sourceInfo.price_display
                    ?? profileSetupInfo.price_display
                    ?? listDataConfig.data.price_display
                    ?? "retail_price",
                with_code: sourceInfo.with_code
                    ?? profileSetupInfo.with_code
                    ?? listDataConfig.data.with_code
                    ?? {},
                preview_stone_count: sourceInfo.preview_stone_count
                    ?? profileSetupInfo.preview_stone_count
                    ?? DEFAULT_PREVIEW_STONE_COUNT,
                image_config: sourceInfo.image_config ?? profileSetupInfo.image_config ?? listDataConfig.data.image_config ?? null,
            };
            const configCheckList = [...(listDataConfig.data.config_check_list || [])];
            if (listDataConfig.data.current_template_layout_selected?.value === "custom_template_01"
                && !configCheckList.includes("stock_id")) {
                configCheckList.push("stock_id");
            }

            return {
                ...prev,
                config_check_list: configCheckList,
                config_check_info: configInfo,
                current_template_layout_selected: listDataConfig.data.current_template_layout_selected,
                custom_template_config: normalizeCustomTemplateConfig(listDataConfig.data.custom_template_config_info),
                custom_template: true,
            };
        })

        setReload((value) => !value)
        setProfileId(_id)


        console.log(checkConfigData)
    }

    // useEffect(()=>{
    //     const iframe = iframeRef.current;
    //     const onLoadHandler = () => {
    //         // Send a message to the iframe after it loads
    //         iframe.contentWindow.postMessage(
    //           { action: 'printcustom',
    //             payload : {

    //             }

    //            }, 
    //           'https://printprn.giscloud.co/' // Specify the iframe's exact origin
    //         );
    //       };

    //       // Attach the load event listener to ensure the iframe has fully loaded
    //       iframe.addEventListener('load', onLoadHandler);

    //       return () => {
    //         iframe.removeEventListener('load', onLoadHandler);
    //       };

    // },[])


    useEffect(() => {

        if (!profileId) {
            fetchConfigList();
        }
    }

        , [profileId, hash])






    // let config = {
    //     "metal": true,
    //     "replaceMetalArea": true,

    // }



    return (



        <barcodePrintOutContext.Provider value={{ checkConfigData, setCheckConfigData }}>



            <div className={`container-fluid barcode_tamplate${pageStatus === "inventory_import_page" ? " is-inventory-import" : ""}`}>
                <div className="stock_id_import_panel" style={{ display: showImportStockIdModal ? "block" : "none" }}>



                    <div className="heading_area">
                        <span class="import_heading_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 10H12.1M7.89999 10H7.99999M16 10H16.1" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 4V16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H13L8 21V17H4C3.73478 17 3.48043 16.8946 3.29289 16.7071C3.10536 16.5196 3 16.2652 3 16V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </span>
                        <h3>Stock ID</h3>
                        <button className="close_import_display_button" onClick={() => {
                            setShowImportStockIdModal(false)
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className="search_area">
                        <textarea className="stock_id_import_text" rows="50" value={stockIdImportList ? stockIdImportList : ""} placeholder="Type your note here." onChange={(e) => {
                            setStockIdImportList(e.target.value)
                        }} />
                        <button className="submit_impoort_stock_id"
                            onClick={() => {
                                importStockIdList(stockIdImportList)
                            }}
                        >Submit</button>
                    </div>
                </div>
                <div className="heading_breadcrumb_block">
                    <ul class="breadcrumb">

                        <li className="non_link">

                            {callerFrom === "" ? "Setup" : "Barcode"}

                            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                        </li>

                        <li className="non_link">
                            <span>Custom Template</span>
                        </li>
                        {pageStatus !== "list_profile_page" ?
                            <>

                                <li onClick={goToListPage}>

                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                                    <span>Barcode Label</span>
                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                                </li>
                            </>


                            : ""}

                        {pageStatus === "print_preview_page" ?

                            <li>
                                <span class="active_page">

                                    Barcode Printing
                                </span>


                            </li>

                            : ""}

                        {pageStatus === "add_profile_page" ?

                            <li >
                                <span class="active_page">

                                    Add Label

                                </span>

                            </li>

                            : ""}


                        {pageStatus === "edit_profile_page" ?

                            <li >
                                <span class="active_page">

                                    Edit Label

                                </span>

                            </li>

                            : ""}


                        {pageStatus === "inventory_import_page" ?

                            <li >
                                <span class="active_page">

                                    Add Inventory

                                </span>

                            </li>

                            : ""}


                    </ul>

                    {pageStatus !== "print_preview_page" && pageStatus !== "print_preview_page" ?
                        // <h1>
                        //     {PageHeadingBreadCrumb.heading}
                        // </h1>
                        ""
                        : ""}

                    {pageStatus === "list_profile_page" ?
                        <button className="add_barcode_label"
                            onClick={() => {
                                setPageStatus("add_profile_page")
                                setPageHeadingBreadCrumb({
                                    heading: "Add Label Profile ",
                                    breadCrumbName: "Add Label ",

                                })
                                window.location.href = "#add_profile_page";


                            }
                            }
                        >+ Add Label</button>
                        : ""}
                    <div id="barcode-heading-actions" className="heading_breadcrumb_block-actions" />


                </div>





                {
                    pageStatus === "add_profile_page" || pageStatus === "edit_profile_page" ?

                        <div className="config_panel_wrapper">
                            <div className="config_panel_block">

                                <ConfigPanel />

                            </div>

                        </div>
                        : ""

                }



                {
                    pageStatus === "list_profile_page" ?


                        <>
                            <div className="profile_print_out_content_block">
                                <div className="top_bar_menu_table">
                                    <div className="limit_block">
                                        <Select
                                            className="limit-select limit_profile_select short"
                                            options={selectLimitOptions}
                                            value={{ label: limit, value: limit }}

                                        />
                                    </div>
                                    <div className="search_find_import">
                                        {checkedLabelIds.length === 1 ?
                                            <span className="clone_icon" onClick={cloneProfileTemplate} style={{ cursor: "pointer" }}>
                                                <img src={base_assets + "images/icons/clone.svg"} alt="clone" width="22" height="22" />
                                            </span>
                                            : ""}
                                        <span className="search_icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M16.927 17.0401L20.4001 20.4001M19.2801 11.4401C19.2801 15.77 15.77 19.2801 11.4401 19.2801C7.11019 19.2801 3.6001 15.77 3.6001 11.4401C3.6001 7.11019 7.11019 3.6001 11.4401 3.6001C15.77 3.6001 19.2801 7.11019 19.2801 11.4401Z" stroke="#A4A4A4" stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span className="print_icon">

                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_6663_33341)">
                                                    <path d="M18.75 17H20C20.5523 17 21 16.5523 21 16V8C21 7.44772 20.5523 7 20 7H4C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H5.25" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12V20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20V12Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6 4C6 3.44772 6.44772 3 7 3H17C17.5523 3 18 3.44772 18 4V7H6V4Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 13.5H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 18.5H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 16H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6663_33341">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <span className="barcode_print" onClick={
                                            () => {
                                                setPageStatus("print_preview_page")
                                                setPageHeadingBreadCrumb({
                                                    heading: "Barcode Printing",
                                                    breadCrumbName: "Barcode Printing",

                                                })
                                                window.location.href = "#print_preview_page";

                                            }
                                        }>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <mask id="path-1-inside-1_6663_16757" fill="white">
                                                    <path d="M3 18.9608H3.58575V5.03857H3V18.9608ZM4.758 18.9608H5.90625V5.03857H4.758V18.9608ZM7.0545 18.9608H8.22675V5.03857H7.0545V18.9608ZM9.375 18.9608H11.7188V5.03857H9.375V18.9608ZM12.867 18.9608H14.625V5.03857H12.867V18.9608ZM15.7733 18.9608H16.9455V5.03857H15.7733V18.9608ZM18.0938 18.9608H18.6795V5.03857H18.0938V18.9608ZM19.8517 18.9608H21V5.03857H19.8517V18.9608Z" />
                                                </mask>
                                                <path d="M3 18.9608H3.58575V5.03857H3V18.9608ZM4.758 18.9608H5.90625V5.03857H4.758V18.9608ZM7.0545 18.9608H8.22675V5.03857H7.0545V18.9608ZM9.375 18.9608H11.7188V5.03857H9.375V18.9608ZM12.867 18.9608H14.625V5.03857H12.867V18.9608ZM15.7733 18.9608H16.9455V5.03857H15.7733V18.9608ZM18.0938 18.9608H18.6795V5.03857H18.0938V18.9608ZM19.8517 18.9608H21V5.03857H19.8517V18.9608Z" fill="#A4A4A4" />
                                                <path d="M3 18.9608H-22V43.9608H3V18.9608ZM3.58575 18.9608V43.9608H28.5858V18.9608H3.58575ZM3.58575 5.03857H28.5858V-19.9614H3.58575V5.03857ZM3 5.03857V-19.9614H-22V5.03857H3ZM4.758 18.9608H-20.242V43.9608H4.758V18.9608ZM5.90625 18.9608V43.9608H30.9062V18.9608H5.90625ZM5.90625 5.03857H30.9062V-19.9614H5.90625V5.03857ZM4.758 5.03857V-19.9614H-20.242V5.03857H4.758ZM7.0545 18.9608H-17.9455V43.9608H7.0545V18.9608ZM8.22675 18.9608V43.9608H33.2267V18.9608H8.22675ZM8.22675 5.03857H33.2267V-19.9614H8.22675V5.03857ZM7.0545 5.03857V-19.9614H-17.9455V5.03857H7.0545ZM9.375 18.9608H-15.625V43.9608H9.375V18.9608ZM11.7188 18.9608V43.9608H36.7188V18.9608H11.7188ZM11.7188 5.03857H36.7188V-19.9614H11.7188V5.03857ZM9.375 5.03857V-19.9614H-15.625V5.03857H9.375ZM12.867 18.9608H-12.133V43.9608H12.867V18.9608ZM14.625 18.9608V43.9608H39.625V18.9608H14.625ZM14.625 5.03857H39.625V-19.9614H14.625V5.03857ZM12.867 5.03857V-19.9614H-12.133V5.03857H12.867ZM15.7733 18.9608H-9.22675V43.9608H15.7733V18.9608ZM16.9455 18.9608V43.9608H41.9455V18.9608H16.9455ZM16.9455 5.03857H41.9455V-19.9614H16.9455V5.03857ZM15.7733 5.03857V-19.9614H-9.22675V5.03857H15.7733ZM18.0938 18.9608H-6.90625V43.9608H18.0938V18.9608ZM18.6795 18.9608V43.9608H43.6795V18.9608H18.6795ZM18.6795 5.03857H43.6795V-19.9614H18.6795V5.03857ZM18.0938 5.03857V-19.9614H-6.90625V5.03857H18.0938ZM19.8517 18.9608H-5.14825V43.9608H19.8517V18.9608ZM21 18.9608V43.9608H46V18.9608H21ZM21 5.03857H46V-19.9614H21V5.03857ZM19.8517 5.03857V-19.9614H-5.14825V5.03857H19.8517ZM3 43.9608H3.58575V-6.03918H3V43.9608ZM28.5858 18.9608V5.03857H-21.4142V18.9608H28.5858ZM3.58575 -19.9614H3V30.0386H3.58575V-19.9614ZM-22 5.03857V18.9608H28V5.03857H-22ZM4.758 43.9608H5.90625V-6.03918H4.758V43.9608ZM30.9062 18.9608V5.03857H-19.0938V18.9608H30.9062ZM5.90625 -19.9614H4.758V30.0386H5.90625V-19.9614ZM-20.242 5.03857V18.9608H29.758V5.03857H-20.242ZM7.0545 43.9608H8.22675V-6.03918H7.0545V43.9608ZM33.2267 18.9608V5.03857H-16.7733V18.9608H33.2267ZM8.22675 -19.9614H7.0545V30.0386H8.22675V-19.9614ZM-17.9455 5.03857V18.9608H32.0545V5.03857H-17.9455ZM9.375 43.9608H11.7188V-6.03918H9.375V43.9608ZM36.7188 18.9608V5.03857H-13.2812V18.9608H36.7188ZM11.7188 -19.9614H9.375V30.0386H11.7188V-19.9614ZM-15.625 5.03857V18.9608H34.375V5.03857H-15.625ZM12.867 43.9608H14.625V-6.03918H12.867V43.9608ZM39.625 18.9608V5.03857H-10.375V18.9608H39.625ZM14.625 -19.9614H12.867V30.0386H14.625V-19.9614ZM-12.133 5.03857V18.9608H37.867V5.03857H-12.133ZM15.7733 43.9608H16.9455V-6.03918H15.7733V43.9608ZM41.9455 18.9608V5.03857H-8.0545V18.9608H41.9455ZM16.9455 -19.9614H15.7733V30.0386H16.9455V-19.9614ZM-9.22675 5.03857V18.9608H40.7733V5.03857H-9.22675ZM18.0938 43.9608H18.6795V-6.03918H18.0938V43.9608ZM43.6795 18.9608V5.03857H-6.3205V18.9608H43.6795ZM18.6795 -19.9614H18.0938V30.0386H18.6795V-19.9614ZM-6.90625 5.03857V18.9608H43.0938V5.03857H-6.90625ZM19.8517 43.9608H21V-6.03918H19.8517V43.9608ZM46 18.9608V5.03857H-4V18.9608H46ZM21 -19.9614H19.8517V30.0386H21V-19.9614ZM-5.14825 5.03857V18.9608H44.8517V5.03857H-5.14825Z" fill="#A4A4A4" mask="url(#path-1-inside-1_6663_16757)" />
                                            </svg>

                                        </span>
                                    </div>
                                </div>
                                <div className="profile_list_table_block position-relative">
                                    <table className="com-custom-table-tag table align-middle profile_list_table">


                                        <thead>
                                            <tr className="text-nowrap align-middle">
                                                <th>
                                                    <div className="com-check">
                                                        <input
                                                            id="check1"
                                                            type="checkbox"
                                                            checked={customTemplateList.length > 0 && checkedLabelIds.length === customTemplateList.length}
                                                            onChange={handleCheckAllLabels}
                                                        />
                                                        <label htmlFor="check1" className="com-check-label" />
                                                    </div>



                                                </th>
                                                <th># </th>
                                                <th>Profile Name </th>
                                                <th>Created Date </th>
                                                <th>Modified Date </th>
                                                <th>Template Type</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {configList ? configList.map((v, k) => (

                                                v.template_layout === "custom_template_01" || v.template_layout === "custom_template_02" ?


                                                    <tr className="text-nowrap align-middle" key={k}>
                                                        <td>

                                                            <div class="com-check">
                                                                <input
                                                                    id={v._id}
                                                                    key={k}
                                                                    type="checkbox"
                                                                    checked={checkedLabelIds.includes(v._id)}
                                                                    onChange={(e) => handleLabelCheck(e, v._id)}
                                                                />
                                                                <label htmlFor={v._id} class="com-check-label"></label>
                                                            </div>
                                                        </td>
                                                        <td>{/* k + 1 */}</td>
                                                        <td>
                                                            <span className="profile_link" onClick={() => {
                                                                editProfile(v._id)
                                                                setPageStatus('edit_profile_page')
                                                                setPageHeadingBreadCrumb({
                                                                    heading: "Edit Barcode Label",
                                                                    breadCrumbName: "Barcode Label",
                                                                })
                                                            }}>

                                                                {v.profile_name}

                                                            </span>

                                                        </td>
                                                        <td>{
                                                            new Date(v.createdAt).toLocaleString('en-TH-u-ca-gregory', {
                                                                day: '2-digit',

                                                                month: '2-digit',
                                                                year: 'numeric',
                                                            })}</td>
                                                        <td>{
                                                            new Date(v.updatedAt).toLocaleString('en-TH-u-ca-gregory', {
                                                                day: '2-digit',

                                                                month: '2-digit',
                                                                year: 'numeric',
                                                            })}</td>
                                                        <td>
                                                            {v.template_layout === "custom_template_01" ?
                                                                "Template-Custom-01-Barcode"
                                                                : "Template-Custom-02-Qrcode"}


                                                        </td>

                                                        <td>
                                                            <span className="action_printout" onClick={() => {
                                                                editProfile(v._id)
                                                                setPageStatus('edit_profile_page')
                                                                setPageHeadingBreadCrumb({
                                                                    heading: "Edit Barcode Label",
                                                                    breadCrumbName: "Barcode Label",
                                                                })
                                                            }}>
                                                                <svg className="edit_icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                                    <path d="M19 15V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H7" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M11.5 14.8L21 5.2L16.8 1L7.3 10.5L7 15L11.5 14.8Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </span>
                                                            <span className="action_printout view_printout_profile">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M22 12.0002C20.2531 15.5764 15.8775 19 11.9998 19C8.12201 19 3.74646 15.5764 2 11.9998" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M22 12.0002C20.2531 8.42398 15.8782 5 12.0005 5C8.1227 5 3.74646 8.42314 2 11.9998" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </span>



                                                            <span className="action_printout remove_printout_profile" onClick={() => {
                                                                if (window.confirm("Do you want to remove this item?")) {
                                                                    deleteProfileTemplate(v._id)

                                                                }
                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M20.25 4.6875H16.3125V3.75C16.3125 3.20299 16.0952 2.67839 15.7084 2.29159C15.3216 1.9048 14.797 1.6875 14.25 1.6875H9.75C9.20299 1.6875 8.67839 1.9048 8.29159 2.29159C7.9048 2.67839 7.6875 3.20299 7.6875 3.75V4.6875H3.75C3.60082 4.6875 3.45774 4.74676 3.35225 4.85225C3.24676 4.95774 3.1875 5.10082 3.1875 5.25C3.1875 5.39918 3.24676 5.54226 3.35225 5.64775C3.45774 5.75324 3.60082 5.8125 3.75 5.8125H4.6875V19.5C4.6875 19.8481 4.82578 20.1819 5.07192 20.4281C5.31806 20.6742 5.6519 20.8125 6 20.8125H18C18.3481 20.8125 18.6819 20.6742 18.9281 20.4281C19.1742 20.1819 19.3125 19.8481 19.3125 19.5V5.8125H20.25C20.3992 5.8125 20.5423 5.75324 20.6477 5.64775C20.7532 5.54226 20.8125 5.39918 20.8125 5.25C20.8125 5.10082 20.7532 4.95774 20.6477 4.85225C20.5423 4.74676 20.3992 4.6875 20.25 4.6875ZM8.8125 3.75C8.8125 3.50136 8.91127 3.2629 9.08709 3.08709C9.2629 2.91127 9.50136 2.8125 9.75 2.8125H14.25C14.4986 2.8125 14.7371 2.91127 14.9129 3.08709C15.0887 3.2629 15.1875 3.50136 15.1875 3.75V4.6875H8.8125V3.75ZM18.1875 19.5C18.1875 19.5497 18.1677 19.5974 18.1326 19.6326C18.0974 19.6677 18.0497 19.6875 18 19.6875H6C5.95027 19.6875 5.90258 19.6677 5.86742 19.6326C5.83225 19.5974 5.8125 19.5497 5.8125 19.5V5.8125H18.1875V19.5ZM10.3125 9.75V15.75C10.3125 15.8992 10.2532 16.0423 10.1477 16.1477C10.0423 16.2532 9.89918 16.3125 9.75 16.3125C9.60082 16.3125 9.45774 16.2532 9.35225 16.1477C9.24676 16.0423 9.1875 15.8992 9.1875 15.75V9.75C9.1875 9.60082 9.24676 9.45774 9.35225 9.35225C9.45774 9.24676 9.60082 9.1875 9.75 9.1875C9.89918 9.1875 10.0423 9.24676 10.1477 9.35225C10.2532 9.45774 10.3125 9.60082 10.3125 9.75ZM14.8125 9.75V15.75C14.8125 15.8992 14.7532 16.0423 14.6477 16.1477C14.5423 16.2532 14.3992 16.3125 14.25 16.3125C14.1008 16.3125 13.9577 16.2532 13.8523 16.1477C13.7468 16.0423 13.6875 15.8992 13.6875 15.75V9.75C13.6875 9.60082 13.7468 9.45774 13.8523 9.35225C13.9577 9.24676 14.1008 9.1875 14.25 9.1875C14.3992 9.1875 14.5423 9.24676 14.6477 9.35225C14.7532 9.45774 14.8125 9.60082 14.8125 9.75Z" fill="#FF5757" />
                                                                </svg>

                                                            </span>

                                                        </td>
                                                    </tr>
                                                    : ""
                                            ))
                                                : ""}
                                        </tbody>
                                    </table>
                                    {showloader && <TableLoader />}
                                </div>

                            </div>


                        </>
                        : ""
                }






            {pageStatus === "inventory_import_page" ?
                <InventorySelectToPrintout />

                : ""}

            </div>

            {pageStatus === "print_preview_page" ?
                <PrintPreview />
                : ""}



        </barcodePrintOutContext.Provider>

    )
}

const ConfigPanel = (props) => {
    let [, setPageStatus] = useRecoilState(pageStatusState)
    let [exampleCustomPrintOutUri, setExampleCustomPrintOutUri] = useRecoilState(exampleCustomPrintOutUriState)

    let profileNameRef = useRef(null)
    let templateSelectionRef = useRef(null)
    const previewRequestRef = useRef(0)
    const skipNextPreviewRenderRef = useRef(false)
    const customLayoutEditingRef = useRef(false)
    const previousCustomStoneFieldsRef = useRef([])
    const priceCodeInputRefs = useRef({})

    const { t } = useTranslation();


    const [update, setUpdate] = useState(false);
    const { checkConfigData, setCheckConfigData } = useContext(barcodePrintOutContext)

    const invalidateCustomPreviewRequests = () => {
        // A PDF created before a drag starts must never replace the editor
        // while its layout is being adjusted locally.
        customLayoutEditingRef.current = true;
        previewRequestRef.current += 1;
    };

    const allowCustomPreviewRender = () => {
        customLayoutEditingRef.current = false;
    };

    const selectTemplatePrintout = (e) => {
        allowCustomPreviewRender();

        let val = { "label": e.label, "value": e.value };
        setCheckConfigData((prev) => {
            if (Object.keys(prev).length > 0) {
                let newObj = prev;
                newObj.current_template_layout_selected = val
                newObj.custom_template = true
                console.log(newObj);
                setUpdate(!update)
                return newObj;
            }

        })




        if (e.value === "custom_template_01") {
            setCheckConfigData((prev) => {
                let prevState = prev
                let obj = prevState;
                console.log(obj, 'config.custom_template_01')

                Object.keys(config.custom_template_01).map((v, k) => {

                    // checkConfigData.config_check_info.price_display

                    if (config.custom_template_01[v]) {
                        obj.config_check_list.push(v)
                        obj.config_check_info.price_display = "retail_price"

                    }
                    return true;
                })

                //console.log(obj.config_check_list,'obj.config_check_list')
                // console.log(obj, 'newobj if')
                setUpdate(!update)

                return obj;

            })
        }

    }





    let [currentSelectTemplate,] = useState(checkConfigData.current_template_layout_selected);


    const checkConfig = (e) => {
        allowCustomPreviewRender();

        const currentCheck = checkConfigData.config_check_list ? checkConfigData.config_check_list : [];

        if (e.target.value !== "") {
            console.log(e.target.checked)
            let prevState;


            if (e.target.checked === true) {
                //config_data:[...checkConfigDataContext,e.target.value],} config_check_list 
                //{config_check_list:[],config_check_info:{}}
                // { 

                setCheckConfigData((prev) => {
                    prevState = prev
                    let obj = prevState;
                    if (Object.keys(prev).length > 0) {
                        obj.config_check_list.push(e.target.value)
                        console.log(obj, 'newobj if')
                        setUpdate(!update)

                        return obj;
                    } else {
                        obj.config_check_list.push(e.target.value)
                        console.log(obj, 'newobj else')

                        setUpdate(!update)

                        return obj
                    }

                })


            } else {

                let filtered = currentCheck.filter(function (item) {
                    return item !== e.target.value
                })




                setCheckConfigData((prev) => {
                    prevState = prev
                    let obj = prevState;

                    obj.config_check_list.splice(0, obj.config_check_list.length);
                    obj.config_check_list.push(...filtered)
                    setUpdate(!update)

                    return obj

                })

            }
        }

    }

    const changeInputWithFieldName = (e, field_name) => {
        allowCustomPreviewRender();
        setCheckConfigData((prev) => {
            return {
                ...prev,
                config_check_info: {
                    ...(prev.config_check_info || {}),
                    [field_name]: e.target.value,
                },
            };
        })

    }

    const focusPriceCodeInput = (key, step) => {
        const order = PRICE_CODE_FIELDS.map((field) => field.key);
        const nextKey = order[order.indexOf(key) + step];
        if (nextKey && priceCodeInputRefs.current[nextKey]) {
            priceCodeInputRefs.current[nextKey].focus();
            priceCodeInputRefs.current[nextKey].select();
        }
    };

    const changePriceCodeChar = (key, rawValue) => {
        allowCustomPreviewRender();
        const char = String(rawValue || "")
            .replace(/\d/g, "")
            .slice(-1)
            .toUpperCase();
        const currentCode = checkConfigData.config_check_info?.with_code || {};
        if (char) {
            const usedBy = Object.keys(currentCode).find(
                (currentKey) => currentKey !== key
                    && currentCode[currentKey]
                    && currentCode[currentKey].toUpperCase() === char
            );
            if (usedBy) {
                const usedLabel = PRICE_CODE_FIELDS.find((field) => field.key === usedBy)?.label || usedBy;
                error(t("Character already used for") + " " + t(usedLabel));
                return;
            }
        }

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                with_code: {
                    ...(prev.config_check_info?.with_code || {}),
                    [key]: char,
                },
            },
        }));
        if (char) focusPriceCodeInput(key, 1);
    };

    const handlePriceCodeKeyDown = (event, key) => {
        if (/^\d$/.test(event.key)) {
            event.preventDefault();
            return;
        }
        if (event.key === "Backspace" && !event.currentTarget.value) {
            event.preventDefault();
            focusPriceCodeInput(key, -1);
        } else if (event.key === "ArrowRight") {
            focusPriceCodeInput(key, 1);
        } else if (event.key === "ArrowLeft") {
            focusPriceCodeInput(key, -1);
        }
    };

    const renderPriceCodeInput = (field) => {
        const value = checkConfigData.config_check_info?.with_code?.[field.key] || "";
        return (
            <input
                id={`custom_template_price_code_${field.key}`}
                ref={(element) => { priceCodeInputRefs.current[field.key] = element; }}
                className={`price_code_field-input${value ? " is-filled" : ""}`}
                type="text"
                maxLength={1}
                autoComplete="off"
                inputMode="text"
                value={value}
                onChange={(event) => changePriceCodeChar(field.key, event.target.value)}
                onKeyDown={(event) => handlePriceCodeKeyDown(event, field.key)}
                onFocus={(event) => event.target.select()}
            />
        );
    };

    const handleCustomTemplateStoneCountChange = (value) => {
        allowCustomPreviewRender();
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                preview_stone_count: normalizePreviewStoneCount(value),
            },
        }));
    };

    const handleCustomTemplateLineSpacingChange = (value) => {
        allowCustomPreviewRender();
        const nextSpacing = Math.min(5, Math.max(0.5, Number(value) || 0.5));
        setCheckConfigData((prev) => ({
            ...prev,
            custom_template_config: {
                ...(prev.custom_template_config || customTemplateConfig),
                stone_data: {
                    ...(prev.custom_template_config?.stone_data || customTemplateConfig.stone_data),
                    line_space_offset: nextSpacing,
                },
            },
        }));
    };

    const handleCustomTemplateImageChange = (nextImageConfig, options = {}) => {
        if (options.skipPreviewRender) {
            skipNextPreviewRenderRef.current = true;
            customLayoutEditingRef.current = true;
            previewRequestRef.current += 1;
        } else {
            allowCustomPreviewRender();
        }
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: nextImageConfig,
            },
        }));
    };

    const handleCustomTemplateSizeChange = ({
        fieldName,
        fontSize,
        fontSizes,
        position,
        positionDelta,
        lockOffsetX,
        skipPreviewRender,
    }) => {
        if (skipPreviewRender) {
            skipNextPreviewRenderRef.current = true;
            customLayoutEditingRef.current = true;
            previewRequestRef.current += 1;
        }
        setCheckConfigData((prev) => {
            const currentConfig = normalizeCustomTemplateConfig(prev.custom_template_config);
            if (fieldName === "stone_data") {
                const delta = positionDelta || { x: 0, y: 0 };
                const nextStoneData = Object.keys(currentConfig.stone_data || {}).reduce((stoneData, stoneFieldName) => {
                    if (stoneFieldName === "line_space_offset" || stoneFieldName === "font_size") {
                        stoneData[stoneFieldName] = currentConfig.stone_data[stoneFieldName];
                        return stoneData;
                    }
                    const stoneField = currentConfig.stone_data[stoneFieldName];
                    const nextFontSize = Number(fontSizes?.[stoneFieldName]);
                    stoneData[stoneFieldName] = stoneField?.position
                        ? {
                            ...stoneField,
                            ...(Number.isFinite(nextFontSize) && nextFontSize > 0
                                ? { font_size: Math.min(20, Math.max(1, nextFontSize)) }
                                : {}),
                            position: {
                                ...stoneField.position,
                                x: Number(stoneField.position.x) + (Number(delta.x) || 0),
                                y: Number(stoneField.position.y) + (Number(delta.y) || 0),
                            },
                        }
                        : stoneField;
                    return stoneData;
                }, {
                    ...currentConfig.stone_data,
                });
                delete nextStoneData.font_size;
                return {
                    ...prev,
                    custom_template_config: {
                        ...currentConfig,
                        stone_data: nextStoneData,
                    },
                };
            }
            const isStoneField = CUSTOM_TEMPLATE_STONE_FIELDS.includes(fieldName);
            const section = isStoneField ? "stone_data" : null;
            const currentField = section
                ? currentConfig.stone_data?.[fieldName]
                : currentConfig[fieldName];
            if (!currentField?.position) return prev;

            const nextField = {
                ...currentField,
                font_size: Math.min(20, Math.max(1, Number(fontSize) || DEFAULT_TEXT_FONT_SIZE)),
                position: {
                    ...currentField.position,
                    ...(position || {}),
                },
            };
            const nextConfig = {
                ...currentConfig,
                ...(section
                    ? {
                        stone_data: {
                            ...currentConfig.stone_data,
                            [fieldName]: nextField,
                        },
                    }
                    : { [fieldName]: nextField }),
            };

            if (lockOffsetX !== undefined && nextConfig.alignment_locks?.[fieldName]?.enabled) {
                nextConfig.alignment_locks = {
                    ...nextConfig.alignment_locks,
                    [fieldName]: {
                        ...nextConfig.alignment_locks[fieldName],
                        offset_x: Number(lockOffsetX) || 0,
                    },
                };
            }

            return { ...prev, custom_template_config: nextConfig };
        });
    };

    const changeCustomTemplateImage = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
            const imageConfig = await prepareBarcodeImage(file);
            handleCustomTemplateImageChange(imageConfig);
        } catch (conversionError) {
            error(conversionError.message || "Unable to prepare image");
            event.target.value = "";
        }
    };

    const changeCustomTemplateImageSize = (event, dimension) => {
        const maximum = dimension === "width" ? 75 : 14;
        const nextValue = Math.min(maximum, Math.max(1, Number(event.target.value) || 1));
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: {
                    ...(prev.config_check_info?.image_config || {}),
                    size: {
                        ...(prev.config_check_info?.image_config?.size || {}),
                        [dimension]: nextValue,
                    },
                },
            },
        }));
    };

    const handleCustomStoneListToggle = () => {
        allowCustomPreviewRender();
        setCheckConfigData((prev) => {
            const currentFields = prev.config_check_list || [];
            const selectedStoneFields = currentFields.filter((fieldName) => (
                CUSTOM_TEMPLATE_STONE_FIELDS.includes(fieldName)
            ));

            if (selectedStoneFields.length > 0) {
                previousCustomStoneFieldsRef.current = selectedStoneFields;
                return {
                    ...prev,
                    config_check_list: currentFields.filter((fieldName) => (
                        !CUSTOM_TEMPLATE_STONE_FIELDS.includes(fieldName)
                    )),
                };
            }

            const fieldsToRestore = previousCustomStoneFieldsRef.current.length > 0
                ? previousCustomStoneFieldsRef.current
                : CUSTOM_TEMPLATE_STONE_FIELDS;
            return {
                ...prev,
                config_check_list: [
                    ...currentFields,
                    ...fieldsToRestore.filter((fieldName) => !currentFields.includes(fieldName)),
                ],
            };
        });
    };

    const changeCustomTemplateStoneDataPositionConfig = (e, config_key, axis) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.custom_template_config.stone_data[config_key].position[axis] = e.target.value;
            setUpdate(!update)
            return obj;
        })

    }
    const changeCustomTemplatePositionConfig = (e, config_key, axis) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.custom_template_config[config_key].position[axis] = parseFloat(e.target.value);
            setUpdate(!update)
            return obj;
        })

    }

    const moveCustomTemplatePositionConfig = (configKey, position, options = {}) => {
        if (options.skipPreviewRender) {
            skipNextPreviewRenderRef.current = true;
            customLayoutEditingRef.current = true;
            previewRequestRef.current += 1;
        }

        setCheckConfigData((prev) => {
            const currentConfig = prev.custom_template_config || customTemplateConfig;
            const nextConfig = { ...currentConfig };

            if (options.stoneRowDelta) {
                nextConfig.stone_data = {
                    ...currentConfig.stone_data,
                };
                Object.keys(nextConfig.stone_data || {}).forEach((fieldName) => {
                    if (fieldName === "line_space_offset") return;
                    const currentPosition = nextConfig.stone_data[fieldName]?.position;
                    if (!currentPosition) return;

                    nextConfig.stone_data[fieldName] = {
                        ...nextConfig.stone_data[fieldName],
                        position: {
                            x: parseFloat(currentPosition.x) + options.stoneRowDelta.x,
                            y: parseFloat(currentPosition.y) + options.stoneRowDelta.y,
                        },
                    };
                });
            } else if (nextConfig.stone_data?.[configKey]?.position) {
                nextConfig.stone_data = {
                    ...currentConfig.stone_data,
                    [configKey]: {
                        ...currentConfig.stone_data[configKey],
                        position: { ...currentConfig.stone_data[configKey].position, ...position }
                    }
                };
            } else if (nextConfig[configKey]?.position) {
                nextConfig[configKey] = {
                    ...currentConfig[configKey],
                    position: { ...currentConfig[configKey].position, ...position }
                };
            }

            if (options.lockOffsetX !== undefined
                && nextConfig.alignment_locks?.[configKey]?.enabled) {
                nextConfig.alignment_locks = {
                    ...nextConfig.alignment_locks,
                    [configKey]: {
                        ...nextConfig.alignment_locks[configKey],
                        offset_x: Number(options.lockOffsetX) || 0,
                    },
                };
            }

            return { ...prev, custom_template_config: nextConfig };
        });
    };

    const handleCustomTemplateLockChange = ({ fieldName, enabled, offsetX }) => {
        setCheckConfigData((prev) => ({
            ...prev,
            custom_template_config: {
                ...(prev.custom_template_config || customTemplateConfig),
                alignment_locks: {
                    ...(prev.custom_template_config?.alignment_locks || {}),
                    [fieldName]: {
                        ...(prev.custom_template_config?.alignment_locks?.[fieldName] || {}),
                        enabled,
                        target: "barcode",
                        axis: "center",
                        offset_x: enabled ? (Number(offsetX) || 0) : 0,
                    },
                },
            },
        }));
    };

    const assignCustomTemplateSource = ({ sourceKey, previousSourceKey, position, stoneIndex = 0 }) => {
        setCheckConfigData((prev) => {
            const currentConfig = normalizeCustomTemplateConfig(prev.custom_template_config);
            const nextConfig = {
                ...currentConfig,
                stone_data: {
                    ...currentConfig.stone_data
                }
            };

            Object.keys(currentConfig.stone_data || {}).forEach((fieldName) => {
                if (fieldName === "line_space_offset") return;
                nextConfig.stone_data[fieldName] = {
                    ...currentConfig.stone_data[fieldName],
                    position: {
                        ...currentConfig.stone_data[fieldName].position
                    }
                };
            });

            const isStoneSource = Boolean(nextConfig.stone_data?.[sourceKey]?.position);
            const nextPosition = {
                x: parseFloat(position.x),
                y: parseFloat(position.y) - (isStoneSource
                    ? (nextConfig.stone_data.line_space_offset || 2.5) * (stoneIndex + 1)
                    : 0)
            };

            if (isStoneSource) {
                nextConfig.stone_data[sourceKey].position = {
                    ...nextConfig.stone_data[sourceKey].position,
                    x: nextPosition.x,
                    y: nextPosition.y
                };
            } else if (nextConfig[sourceKey]?.position) {
                nextConfig[sourceKey] = {
                    ...nextConfig[sourceKey],
                    position: {
                        ...nextConfig[sourceKey].position,
                        x: nextPosition.x,
                        y: nextPosition.y
                    }
                };
            } else {
                return prev;
            }

            const currentFields = prev.config_check_list || [];
            const nextFields = currentFields.filter((fieldName) => (
                fieldName !== previousSourceKey || previousSourceKey === "sku"
            ));
            if (sourceKey !== "sku" && !nextFields.includes(sourceKey)) {
                nextFields.push(sourceKey);
            }

            return {
                ...prev,
                config_check_list: nextFields,
                custom_template_config: nextConfig
            };
        });
    };

    const changeCustomTemplateSizeConfig = (e, config_key, pointer) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.custom_template_config[config_key].size[pointer] = parseFloat(e.target.value);
            setUpdate(!update)
            return obj;
        })

    }
    const changeSelectWithFieldName = (e, field_name) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.config_check_info[field_name] = e.value;
            setUpdate(!update)
            return obj;
        })

    }




    const checkListToObject = (data) => {
        const { template, checkList } = data;

        let conf = {}
        Object.keys(config[template]).map((v, k) => {
            conf[v] = checkList.includes(v);
            return true;

        })
        return conf
    }
    const saveProfile = async (configData) => {
        const { config_check_info, config_check_list, current_template_layout_selected } = configData.profile_config;
        const { t } = configData;
        const templateConfigData = checkListToObject({ template: current_template_layout_selected.value, checkList: config_check_list })
        templateConfigData.preview_stone_count = normalizePreviewStoneCount(config_check_info.preview_stone_count);
        templateConfigData.text_message = config_check_info.text_message || "";
        templateConfigData.text_font_size = normalizeTextFontSize(config_check_info.text_font_size);
        templateConfigData.image_config = config_check_info.image_config || null;
        templateConfigData.with_code = config_check_info.with_code || {};

        const custom_template_config_info = configData.profile_config.hasOwnProperty('custom_template_config') ? configData.profile_config.custom_template_config : {}

        const payload = {
            profile_name: config_check_info.profile_name,
            barcode_display: config_check_info.barcode_display,
            weight_display: config_check_info.weight_display,
            price_display: config_check_info.price_display,
            qr_type_display: config_check_info.qr_type_display,
            qr_url_display: config_check_info.qr_url_display,
            qr_url_depend_location: config_check_info.qr_url_depend_location,
            text_message: config_check_info.text_message,
            text_font_size: templateConfigData.text_font_size,
            image_config: templateConfigData.image_config,
            with_code: templateConfigData.with_code,
            profile_setup_info: templateConfigData,
            template_type: "barcode_printout_template",
            custom_template_config_info: custom_template_config_info,
            template_layout: current_template_layout_selected.value
        }

        const createData = await _Api(payload, 'api/v1/template-printout/create')
        if (createData) {
            let GetloadingID = loading();

            Updateloading(t, GetloadingID, t("Successfully Add Printing Layout"));
            setUpdate(!update)
            window.location.reload(false)
        } else {

        }
        console.log(createData)
    }
    const updateProfile = async (configData) => {
        let payload;
        const { config_check_info, config_check_list, current_template_layout_selected } = configData.profile_config;
        const { t } = configData;
        const templateConfigData = checkListToObject({ template: current_template_layout_selected.value, checkList: config_check_list })
        templateConfigData.preview_stone_count = normalizePreviewStoneCount(config_check_info.preview_stone_count);
        templateConfigData.text_message = config_check_info.text_message || "";
        templateConfigData.text_font_size = normalizeTextFontSize(config_check_info.text_font_size);
        templateConfigData.image_config = config_check_info.image_config || null;
        templateConfigData.with_code = config_check_info.with_code || {};
        const custom_template_config_info = configData.profile_config.hasOwnProperty('custom_template_config') ? configData.profile_config.custom_template_config : {}
        console.log(configData.profile_config, 'configData.profile_config')
        console.log(configData, 'configData.profile_config')
        if (typeof config_check_info.qr_type_display == "undefined") {
            payload = {
                _id: config_check_info._id,
                profile_name: config_check_info.profile_name,
                barcode_display: config_check_info.barcode_display,
                weight_display: config_check_info.weight_display,
                price_display: config_check_info.price_display,
                text_message: config_check_info.text_message,
                text_font_size: templateConfigData.text_font_size,
                image_config: templateConfigData.image_config,
                with_code: templateConfigData.with_code,
                profile_setup_info: templateConfigData,
                custom_template_config_info: custom_template_config_info,
                template_type: "barcode_printout_template",
                template_layout: current_template_layout_selected.value
            }
        } else {

            payload = {
                _id: config_check_info._id,
                barcode_display: config_check_info.barcode_display,
                profile_name: config_check_info.profile_name,
                weight_display: config_check_info.weight_display,
                price_display: config_check_info.price_display,
                qr_type_display: config_check_info.qr_type_display,
                qr_url_display: config_check_info.qr_url_display,
                qr_url_depend_location: config_check_info.qr_url_depend_location,
                text_message: config_check_info.text_message,
                text_font_size: templateConfigData.text_font_size,
                image_config: templateConfigData.image_config,
                with_code: templateConfigData.with_code,
                profile_setup_info: templateConfigData,
                custom_template_config_info: custom_template_config_info,

                template_type: "barcode_printout_template",
                template_layout: current_template_layout_selected.value
            }
        }




        console.log(payload)

        const updateData = await _Api(payload, 'api/v1/template-printout/update')
        if (updateData) {
            let GetloadingID = loading();

            Updateloading(t, GetloadingID, t("Successfully Update Printing Layout"));
            setUpdate(!update)
            window.location.reload(false)
        } else {

        }
    }




    const setBarCodeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.barcode_display === "stock_id") {
            objSelect = {
                "label": "Stock ID",
                "value": "stock_id"
            }
        } else {
            objSelect = {
                "label": "SKU",
                "value": "sku"

            }
        }
        return objSelect;
    }

    const setQrTypeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.qr_type_display === "online") {
            objSelect = {
                "label": "Online",
                "value": "online"
            }
        } else if (checkConfigData.config_check_info.qr_type_display === "product_page") {
            objSelect = {
                "label": "Product Page",
                "value": "product_page"

            }
        } else {
            objSelect = {
                "label": "Offline",
                "value": "offline"

            }
        }
        return objSelect;
    }


    const setWeightTypeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.qr_type_display === "gwt") {
            objSelect = {
                "label": "GWT",
                "value": "gwt"
            }
        } else {
            objSelect = {
                "label": "Nwt",
                "value": "nwt"

            }
        }
        return objSelect;
    }



    const setPriceDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.price_display === "retail_price") {
            objSelect = {
                "label": "Retail Price",
                "value": "retail_price"
            }
        }
        if (checkConfigData.config_check_info.price_display === "with_currency") {
            objSelect = {
                "label": "With Currency",
                "value": "with_currency"
            }
        }
        if (checkConfigData.config_check_info.price_display === "with_code") {
            objSelect = {
                "label": "Price Code",
                "value": "with_code"
            }
        }
        if (checkConfigData.config_check_info.price_display === "with_custom_code") {
            objSelect = {
                "label": "Custom Price Code",
                "value": "with_custom_code"
            }
        }
        return objSelect;
    }




    const genUri = async (config) => {
        if (customLayoutEditingRef.current) return;

        const requestId = ++previewRequestRef.current;

        const previewConfig = {
            ...getSelectedCustomTemplatePreviewConfig(config.custom_template_01, checkConfigData.config_check_list),
            preview_stone_count: normalizePreviewStoneCount(checkConfigData.config_check_info?.preview_stone_count),
            price_display: checkConfigData.config_check_info?.price_display || "retail_price",
            with_code: checkConfigData.config_check_info?.with_code || {},
        };
        let uridata = await CustomTemplateExample(previewConfig, checkConfigData.custom_template_config)
        console.log(uridata, 'uridata')

        if (requestId !== previewRequestRef.current) return;

        // const blob = fetch(uridata).then(res => res.blob());
        // blob.then(pdfBlob => {
        //   const blobUrl = URL.createObjectURL(pdfBlob);
        //   setPdfUri(blobUrl)

        // });

        // (templateProfileId, selectList, dataList, returnType = "save")

        // Base64 string (example, replace with your Base64 string)

        if (uridata) {

            const base64String = uridata.replace('data:application/pdf;filename=generated.pdf;base64,', ''); // Your Base64 content (excluding "data:application/pdf;base64,")
            //  console.log(base64String,'base64String')
            // Step 1: Decode the Base64 string
            const binaryString = atob(base64String);

            // Step 2: Convert binary string to Uint8Array
            const binaryData = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                binaryData[i] = binaryString.charCodeAt(i);
            }

            // Step 3: Create a Blob from the binary data
            const blob = new Blob([binaryData], { type: "application/pdf" });

            // Step 4: Create an Object URL
            const objectUrl = URL.createObjectURL(blob);

            // Step 5: Assign Object URL to the iframe
            if (requestId === previewRequestRef.current) {
                setExampleCustomPrintOutUri(objectUrl)
            }
        }




    }
    const previewStateSignature = JSON.stringify({
        selectedFields: checkConfigData.config_check_list,
        selectedTemplate: checkConfigData.current_template_layout_selected,
        previewStoneCount: checkConfigData.config_check_info?.preview_stone_count,
        lineSpacing: checkConfigData.custom_template_config?.stone_data?.line_space_offset,
        priceDisplay: checkConfigData.config_check_info?.price_display,
        priceCode: checkConfigData.config_check_info?.with_code,
        textMessage: checkConfigData.config_check_info?.text_message,
        textFontSize: checkConfigData.config_check_info?.text_font_size,
        imageSource: checkConfigData.config_check_info?.image_config?.data,
    });

    useEffect(() => {
        if (skipNextPreviewRenderRef.current) {
            skipNextPreviewRenderRef.current = false;
            return;
        }

        genUri(config)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previewStateSignature])

    const customTemplateActiveFields = [...new Set([
        "sku",
        ...(checkConfigData.config_check_list || []).map((fieldName) => (
            fieldName === "item" ? "stock_id" : fieldName
        )),
    ])];
    const customStoneListVisible = (checkConfigData.config_check_list || [])
        .some((fieldName) => CUSTOM_TEMPLATE_STONE_FIELDS.includes(fieldName));
    const customTemplateLineSpacing = Number(
        checkConfigData.custom_template_config?.stone_data?.line_space_offset
    ) || 2.5;

    return (

        <React.Fragment>



            <h2>Create Label</h2>

            <div className={checkConfigData.current_template_layout_selected.value === "custom_template_01" || checkConfigData.current_template_layout_selected.value === "custom_template_02" ? "custom_template_builder_layout" : ""}>
            <div className={checkConfigData.current_template_layout_selected.value === "custom_template_01" || checkConfigData.current_template_layout_selected.value === "custom_template_02" ? "barcode_config_panel custom_template_printout" : "barcode_config_panel"}>


                <div style={{ marginLeft: "15px", marginBottom: "20px", position: "relative" }} ref={profileNameRef}>
                    <Label className="profile_name_label" >
                        Label <span style={{ color: "red" }}>*</span>
                    </Label>

                    <input type="text" id="profile_name" placeholder="Fill your label name" value={checkConfigData.config_check_info.profile_name ? checkConfigData.config_check_info.profile_name : ""} onChange={(e) => {
                        changeInputWithFieldName(e, 'profile_name')
                    }} />

                </div>




                <Select
                    styles={{

                        control: (base, state) => ({
                            ...base,
                            '&:focus': { border: '1px solid red', boxShadow: '1px solid red', borderColor: 'red' }, // border style on hover
                            border: '1px solid lightgray', // default border color
                            boxShadow: 'none', // no box-shadow
                        }),
                    }}
                    className="short template_select"
                    options={checkConfigData.selected_options}
                    value={checkConfigData.current_template_layout_selected}
                    onChange={selectTemplatePrintout}
                    ref={templateSelectionRef}
                // defaultValue={checkConfigData.current_template_layout_selected?checkConfigData.current_template_layout_selected:{label: "please select template name", value: ""}}
                />


                <div className="check_uncheck_block">
                    <button className="check_select_button check_all_config"
                        onClick={() => {
                            setCheckConfigData((prev) => {
                                let obj = prev;
                                if (selectTemplatePrintout === "template_01") {
                                    obj.config_check_list = ["item", "collection", "item_size", "stone_size", "stone_name", "barcode", "metal", "stone_pcs", "cut", "stone_group", "price", "clarity", "shape", "weight", "text", "color", "stone_weight"];

                                } else {
                                    obj.config_check_list = ["item", "collection", "item_size", "stone_size", "stone_name", "qr", "barcode", "metal", "stone_pcs", "cut", "stone_group", "price", "clarity", "shape", "weight", "text", "color", "stone_weight"];

                                }
                                setUpdate(!update)

                                return obj;
                            })
                        }}
                    >Select All</button>
                    <button className="check_select_button uncheck_all_config" onClick={() => {
                        setCheckConfigData((prev) => {
                            let obj = prev;
                            obj.config_check_list = [];
                            setUpdate(!update)

                            return obj;
                        })
                    }} >Unselect All</button>
                    {checkConfigData.current_template_layout_selected?.value === "custom_template_01" && (
                        <button
                            type="button"
                            className="check_select_button custom_template_stone_toggle"
                            onClick={handleCustomStoneListToggle}
                            title={customStoneListVisible ? "Hide stone list" : "Show stone list"}
                            aria-label={customStoneListVisible ? "Hide stone list" : "Show stone list"}
                        >
                            {customStoneListVisible
                                ? <FiEye aria-hidden="true" />
                                : <FiEyeOff aria-hidden="true" />}
                        </button>
                    )}
                </div>
                {!checkConfigData.current_template_layout_selected ? "" : checkConfigData.current_template_layout_selected.value.search('template') >= 0 ?

                    <div className="config_block" id={checkConfigData.current_template_layout_selected.value ? checkConfigData.current_template_layout_selected.value : ""}>


                        {Object.keys(config[checkConfigData.current_template_layout_selected.value]).map((v, k, a) => {
                            console.log(v, 'v loop')
                            return (


                                <div className='barcode-label-select ' key={k}>


                                    {
                                        v === "s" ? <div></div> : ""
                                    }
                                    <div className="barcode_block">
                                        <input className='' type='checkbox' id={v} value={v} checked={checkConfigData.config_check_list.includes(v) ? true : false} onClick={checkConfig} />

                                        <label className='text-center bg-f2 ml-3' style={{ marginLeft: "5px" }} htmlFor={v} key={k} >{t(v).replace(/_/g, ' ')}</label>

                                        {checkConfigData.current_template_layout_selected.value === "custom_template_01" || checkConfigData.current_template_layout_selected.value === "custom_template_02" ? v !== "barcode" && v !== "text" && v !== "weight" && v !== "image"
                                            ?
                                            <div className="block input_x_y">

                                                <div className="input_block">
                                                    <div className="content">
                                                        <h4>X</h4>
                                                        <input type="number" step=".01"
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    genUri(config)
                                                                }
                                                            }}
                                                            onChange={(e) => {

                                                                if (checkConfigData.custom_template_config.stone_data.hasOwnProperty(v)) {
                                                                    changeCustomTemplateStoneDataPositionConfig(e, v, 'x')

                                                                } else {
                                                                    changeCustomTemplatePositionConfig(e, v, 'x')

                                                                }

                                                            }}

                                                            value={
                                                                checkConfigData.custom_template_config.stone_data.hasOwnProperty(v) ? checkConfigData.custom_template_config.stone_data[v].position.x : checkConfigData.custom_template_config[v]?.position.x
                                                            } />

                                                    </div>
                                                </div>


                                                <div className="input_block">

                                                    <div className="content">
                                                        <h4>Y</h4>

                                                        <input type="number" step=".01"
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    genUri(config)
                                                                }
                                                            }}

                                                            onChange={(e) => {

                                                                if (checkConfigData.custom_template_config.stone_data.hasOwnProperty(v)) {
                                                                    changeCustomTemplateStoneDataPositionConfig(e, v, 'y')

                                                                } else {
                                                                    changeCustomTemplatePositionConfig(e, v, 'y')

                                                                }

                                                            }}

                                                            value={
                                                                checkConfigData.custom_template_config.stone_data.hasOwnProperty(v) ? checkConfigData.custom_template_config.stone_data[v].position.y : checkConfigData.custom_template_config[v]?.position.y
                                                            } />
                                                    </div>
                                                </div>

                                            </div>

                                            : ""


                                            : ""}
                                    </div>


                                    {
                                        v.search("barcode") >= 0 && checkConfigData.config_check_list.includes("barcode") ?
                                            <div className="sku_stockid_block">

                                                <Select
                                                    required="required"
                                                    className="barcode_display barcode_selection sku_stockid_selection"
                                                    placeholder="Select data what you need to show in barcode  "
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "SKU",
                                                            "value": "sku"
                                                        },
                                                        {
                                                            "label": "Stock ID",
                                                            "value": "stock_id"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'barcode_display')
                                                    }}
                                                    defaultValue={setBarCodeDisplaySelectLabel(checkConfigData.config_check_info.barcode_display)}
                                                />

                                                {checkConfigData.current_template_layout_selected.value === "custom_template_01" || checkConfigData.current_template_layout_selected.value === "custom_template_02" ?
                                                    <div className="block input_x_y">

                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>X</h4>
                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        changeCustomTemplatePositionConfig(e, 'barcode', 'x')
                                                                    }} value={checkConfigData.custom_template_config.barcode.position.x} />

                                                            </div>
                                                        </div>


                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>Y</h4>

                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}

                                                                    onChange={(e) => {
                                                                        changeCustomTemplatePositionConfig(e, 'barcode', 'y')
                                                                    }} value={checkConfigData.custom_template_config.barcode.position.y} />
                                                            </div>
                                                        </div>

                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>W</h4>
                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        changeCustomTemplateSizeConfig(e, 'barcode', 'width')
                                                                    }}
                                                                    value={checkConfigData.custom_template_config.barcode.size.width}
                                                                />

                                                            </div>
                                                        </div>

                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>H</h4>
                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        changeCustomTemplateSizeConfig(e, 'barcode', 'height')
                                                                    }}
                                                                    value={checkConfigData.custom_template_config.barcode.size.height}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    : ""}






                                            </div>
                                            : ""
                                    }

                                    {
                                        v.search("weight") === 0 && checkConfigData.config_check_list.includes("weight") ?
                                            <div className="weight_selection_block">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection weight_display"
                                                    placeholder={t('Select weight type what you need to show in barcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "GWT",
                                                            "value": "gwt"
                                                        },
                                                        {
                                                            "label": "NWT",
                                                            "value": "nwt"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'weight_display')
                                                    }}

                                                    defaultValue={setWeightTypeDisplaySelectLabel(checkConfigData.config_check_info.weight_display)}
                                                />

                                                {checkConfigData.current_template_layout_selected.value === "custom_template_01" || checkConfigData.current_template_layout_selected.value === "custom_template_02" ?
                                                    <div className="block input_x_y">

                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>X</h4>
                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        changeCustomTemplatePositionConfig(e, 'weight', 'x')
                                                                    }} value={checkConfigData.custom_template_config.weight.position.x} />

                                                            </div>
                                                        </div>


                                                        <div className="input_block">
                                                            <div className="content">
                                                                <h4>Y</h4>

                                                                <input type="number" step=".01"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            genUri(config)
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        changeCustomTemplatePositionConfig(e, 'weight', 'y')
                                                                    }} value={checkConfigData.custom_template_config.weight.position.y} />
                                                            </div>
                                                        </div>

                                                    </div>

                                                    : ""}


                                            </div>
                                            : ""}

                                    {
                                        v.search("text") === 0 && checkConfigData.config_check_list.includes("text") ?
                                            <div className="text_input_block">

                                                <input type="text" placeholder="Ex. Made From Thailand" className="barcode_custom_value_input" id="text_message" style={{}} onChange={(e) => {
                                                    changeInputWithFieldName(e, 'text_message')
                                                }} value={checkConfigData.config_check_info.text_message ? checkConfigData.config_check_info.text_message : ""}


                                                />
                                                <label className="barcode_text_font_size_label" htmlFor="custom_template_text_font_size">Font size</label>
                                                <input
                                                    type="number"
                                                    id="custom_template_text_font_size"
                                                    className="barcode_text_font_size_input"
                                                    min="1"
                                                    max="20"
                                                    step="0.5"
                                                    value={normalizeTextFontSize(checkConfigData.config_check_info.text_font_size)}
                                                    onChange={(e) => changeInputWithFieldName(e, 'text_font_size')}
                                                />
                                            </div>
                                            : ""
                                    }

                                    {
                                        v.search("image") === 0 && checkConfigData.config_check_list.includes("image") ?
                                            <div className="barcode_image_input_block">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="barcode_image_input"
                                                    onChange={changeCustomTemplateImage}
                                                />
                                                <div className="barcode_image_settings_row">
                                                    {checkConfigData.config_check_info?.image_config?.data ? (
                                                        <img
                                                            className="barcode_image_config_preview"
                                                            src={checkConfigData.config_check_info.image_config.data}
                                                            alt="Grayscale label image"
                                                        />
                                                    ) : (
                                                        <span className="barcode_image_help">Grayscale PNG, max 2 MB source</span>
                                                    )}
                                                    <div className="barcode_image_size_block">
                                                        <label htmlFor="custom_template_image_width">W (mm)</label>
                                                        <input
                                                            id="custom_template_image_width"
                                                            type="number"
                                                            min="1"
                                                            max="75"
                                                            step="0.1"
                                                            value={checkConfigData.config_check_info?.image_config?.size?.width ?? 8}
                                                            onChange={(event) => changeCustomTemplateImageSize(event, "width")}
                                                        />
                                                        <label htmlFor="custom_template_image_height">H (mm)</label>
                                                        <input
                                                            id="custom_template_image_height"
                                                            type="number"
                                                            min="1"
                                                            max="14"
                                                            step="0.1"
                                                            value={checkConfigData.config_check_info?.image_config?.size?.height ?? 8}
                                                            onChange={(event) => changeCustomTemplateImageSize(event, "height")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : ""
                                    }

                                    {
                                        v.search("price") === 0 && checkConfigData.config_check_list.includes("price") ?
                                            <div className="text_seletion_block price_selection_block">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection weight_selection price_selection"
                                                    placeholder={t('Select price data to show in barcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "Retail Price",
                                                            "value": "retail_price"
                                                        },

                                                        {
                                                            "label": "With Currency",
                                                            "value": "with_currency"
                                                        },
                                                        {
                                                            "label": "Price Code",
                                                            "value": "with_code"
                                                        },
                                                        {
                                                            "label": "Custom Price Code",
                                                            "value": "with_custom_code"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'price_display')
                                                    }}
                                                    defaultValue={setPriceDisplaySelectLabel(checkConfigData.config_check_list.price_display)}
                                                />

                                                {checkConfigData.config_check_info.price_display === "with_code" ? (
                                                    <div className="price_code_panel custom_template_price_code_panel">
                                                        <div className="price_code_panel-head">
                                                            <h3 className="price_code_panel-title">{t("Price Code")}</h3>
                                                            <p className="price_code_panel-hint">
                                                                {t("One character per key. The price prints as this code instead of digits.")}
                                                            </p>
                                                        </div>
                                                        <div className="price_code_group">
                                                            <span className="price_code_group-label">{t("Digits")}</span>
                                                            <div className="price_code_panel-grid">
                                                                {PRICE_CODE_DIGIT_FIELDS.map((field) => (
                                                                    <div className="price_code_field" key={field.key}>
                                                                        <label className="price_code_field-label" htmlFor={`custom_template_price_code_${field.key}`}>
                                                                            {field.label}
                                                                        </label>
                                                                        {renderPriceCodeInput(field)}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="price_code_group">
                                                            <span className="price_code_group-label">{t("Special")}</span>
                                                            <div className="price_code_specials">
                                                                {PRICE_CODE_SPECIAL_FIELDS.map((field) => (
                                                                    <div className="price_code_special" key={field.key}>
                                                                        {renderPriceCodeInput(field)}
                                                                        <div className="price_code_special-text">
                                                                            <label className="price_code_special-label" htmlFor={`custom_template_price_code_${field.key}`}>
                                                                                {t(field.label)}
                                                                            </label>
                                                                            <span className="price_code_special-hint">{t(field.hint)}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="price_code_preview">
                                                            <span className="price_code_preview-label">{t("Preview")}</span>
                                                            <span className="price_code_preview-input">1,250.00</span>
                                                            <span className="price_code_preview-arrow">-&gt;</span>
                                                            <span className="price_code_preview-code">
                                                                {encodePriceWithCode(
                                                                    "1,250.00",
                                                                    checkConfigData.config_check_info.with_code || {}
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : null}

                                            </div>
                                            : ""
                                    }
                                    {
                                        v.search("qr") === 0 && checkConfigData.config_check_list.includes("qr") ?
                                            <div className="text_seletion_block">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection qr_type_selection"
                                                    placeholder={t('Select type of qrcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "Offline",
                                                            "value": "offline"
                                                        },
                                                        {
                                                            "label": "Online",
                                                            "value": "online"
                                                        },
                                                        {
                                                            "label": "Product Page",
                                                            "value": "product_page"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'qr_type_display')
                                                    }}
                                                    value={setQrTypeDisplaySelectLabel(checkConfigData.config_check_info.barcode_display)}
                                                />

                                                {checkConfigData.config_check_info.qr_type_display === "online" ?
                                                    <div className="qr_url_display">
                                                        <input type="text" onChange={(e) => {
                                                            changeInputWithFieldName(e, 'qr_url_display')
                                                        }} value={checkConfigData.config_check_info.qr_url_display ? checkConfigData.config_check_info.qr_url_display : ""} />

                                                    </div>
                                                    : ""}

                                                {/* {checkConfigData.config_check_info.qr_type_display=="online"? 
                        <div className="qr_url_display">
                     <label className='text-center bg-f2 ml-3' style={{marginRight:"5px"}} htmlFor="depend_on_location" >Depend on location store</label>
        
                            <input type="checkbox" id="depend_on_location"  onChange={checkDependStoreLocation}/>
        
                        </div>
                        :""} */}


                                            </div>


                                            : ""
                                    }


                                </div>
                            )

                        }




                        )}



                    </div>

                    : ""}

                <div className="action_profile_block">
                    <div className="add_profile">


                        <button
                            className="cancel_profile_data"
                            type="button"
                            onClick={() => {
                                // config_check_list:[],config_check_info:{},current_template_layout_selected:"",selected_options:selectOptions
                                setPageStatus("list_profile_page")
                                setCheckConfigData((prev) => {
                                    let obj = prev
                                    obj.config_check_list = []
                                    obj.config_check_info = {}
                                    obj.current_template_layout_selected = ""
                                    return obj
                                }



                                )


                            }}
                        >

                            {t('Cancel')}
                        </button>

                        {checkConfigData.config_check_info._id ?
                            <button
                                className="save_barcode_printout"
                                type="button"
                                onClick={() => {

                                    updateProfile({ template: currentSelectTemplate.value, profile_config: checkConfigData, t: t, })

                                }}
                            >

                                {t('Update')}
                            </button>


                            :
                            <>

                                <button
                                    className="save_barcode_printout"
                                    type="button"
                                    onClick={() => {
                                        if (!checkConfigData.config_check_info.profile_name) {

                                            profileNameRef.current.children[0].focus()
                                            profileNameRef.current.children[1].focus()
                                            // profileNameRef.current.getElementById("profile_name");
                                        }
                                        if (!checkConfigData.current_template_layout_selected.value) {
                                            templateSelectionRef.current.focus()
                                        }
                                        saveProfile({ template: currentSelectTemplate.value, profile_config: checkConfigData, t: t })

                                    }}
                                >

                                    {t('Save')}
                                </button>

                            </>


                        }


                    </div>
                </div>
            </div>
            {checkConfigData.custom_template && exampleCustomPrintOutUri ?
                <div className="custom_template_example">
                    <CustomTemplatePreviewEditor
                        pdfUri={exampleCustomPrintOutUri}
                        customTemplateConfig={checkConfigData.custom_template_config}
                        activeFields={customTemplateActiveFields}
                        forceDefaultSku={false}
                        stoneCount={normalizePreviewStoneCount(checkConfigData.config_check_info?.preview_stone_count)}
                        onStoneCountChange={handleCustomTemplateStoneCountChange}
                        lineSpacing={customTemplateLineSpacing}
                        onLineSpacingChange={handleCustomTemplateLineSpacingChange}
                        stoneListVisible={customStoneListVisible}
                        onStoneListToggle={handleCustomStoneListToggle}
                        previewText={checkConfigData.config_check_info?.text_message || "Text"}
                        previewTextFontSize={normalizeTextFontSize(checkConfigData.config_check_info?.text_font_size)}
                        priceDisplay={checkConfigData.config_check_info?.price_display || "retail_price"}
                        priceCode={checkConfigData.config_check_info?.with_code || {}}
                        imageConfig={checkConfigData.config_check_info?.image_config}
                        onImageChange={handleCustomTemplateImageChange}
                        onSizeChange={handleCustomTemplateSizeChange}
                        onPreviewInteractionStart={invalidateCustomPreviewRequests}
                        stoneFontSizeByLength
                        onPositionChange={moveCustomTemplatePositionConfig}
                        onSourceAssign={assignCustomTemplateSource}
                        onLockChange={handleCustomTemplateLockChange}
                    />
                </div>
                : ""}
            </div>
            {/* custom_template example_iframe */}

        </React.Fragment>
    )


}


const CustomTemplatePrintout = () => {
    return (
        <RecoilRoot>
            <BarcodePrintOutPage />

        </RecoilRoot>

    )

}
export { CustomTemplatePreviewEditor, customTemplateConfig };
export default CustomTemplatePrintout;
